export const esLangDashboard = {
  common: {
    you: 'Tú',
    post: 'Publicación',
    article: 'Artículo',
    create: 'Crear',
    message: 'Mensaje',
    popular: 'Popular',
    emptyIntegrations: 'Primero necesita agregar integraciones',
    categories: 'Categorías',
    edit: 'Editar',
    share: 'Compartir',
    plan: 'Plan',
    sort: 'Ordenar',
    addArticle: 'Agregar artículo',
    articles: 'Artículos',
    users: 'usuarios',
    scans: 'escaneos',
    clicks: 'clics',
    copy: 'Copiar',
    customize: 'Personalizar',
    link: 'enlace',
    save: 'Guardar',
    uploadFile: 'Subir archivo',
    customImage: 'Imagen personalizada',
    customImageTooltip: 'Subir imagen personalizada',
    size: 'Tamaño',
    sizeTooltip: 'Arrastre el control deslizante para establecer el tamaño',
    auto: 'Automático',
    rectangle: 'Rectángulo',
    custom: 'Personalizado',
    clean: 'Limpiar',
    cleaning: 'Limpiando',
    download: 'Descargar',
    downloading: 'Descargando',
    preview: 'VISTA PREVIA',
    cover: 'Portada',
    coverTooltip: 'Subir una foto de portada',
    title: 'Título',
    new: 'Nuevo',
    pro: 'Pro',
    free: 'Gratis',
    limit: 'Límite',
    websites: 'sitios web',
    site: 'Sitio',
    apiKey: 'API Key',
    name: 'Nombre',
    passwordChange: 'Cambio de contraseña',
    draft: 'Borrador',
    page: 'Página',
    areYouSure: '¿Está seguro?',
    drop: 'Soltar',
    video: 'video',
    image: 'imagen',
    chooseFile: 'Elegir archivo',
    nothingFound: 'No se encontró nada',
    enterCorrectLink: 'Ingrese un enlace correcto',
    off: 'Desactivado',
    disconnect: 'DESCONECTAR',
    connect: 'CONECTAR',
    copied: 'Copiado',
    saved: 'Guardado',
    lostConnection: 'Conexión perdida',
    addedCategory: 'Categoría agregada',
    none: 'Ninguno',
    left: 'Izquierda',
    right: 'Derecha',
    solid: 'Sólido',
    double: 'Doble',
    welcome: 'Bienvenido',
    category: 'Categoría',
    product: 'Producto',
    website: 'Sitio web',
    items: 'Elementos',
    square: 'Cuadrado',
    round: 'Redondo',
    border: 'Borde',
    shadow: 'Sombra',
    soft: 'Suave',
    hard: 'Fuerte',
    block: 'Bloque',
    primary: 'Principal',
    additional: 'Adicional',
    normal: 'Normal',
    bold: 'Negrita',
    uploadVideo: 'Subir video',
    compact: 'Compacto',
    card: 'Tarjeta',
    top: 'Arriba',
    center: 'Centro',
    bottom: 'Abajo',
    button: 'Botón',
    addNewItem: 'Agregar nuevo elemento',
    price: 'Precio',
    priceCaption: 'Agregue el precio de su producto',
    oldPrice: 'Precio anterior',
    oldPriceCaption: 'El precio anterior se mostrará tachado',
    areYouSureDeleteItem: '¿Está seguro de que desea eliminar este elemento?',
    add: 'Agregar',
    active: 'Activo',
    isActive: 'está activo',
    isDisabled: 'está desactivado',
    uploadImage: 'Subir imagen',
    design: 'Diseño',
    addAccount: 'Agregar cuenta',
    hey: 'Hola',
    activeBackground: 'Fondo activo',
    activeText: 'Texto activo',
    connectDomain: 'Conectar dominio',
    shortLink: 'Enlace corto',
    appearanceSaved: '¡Apariencia guardada!',
    blockAdded: '¡Bloque agregado!',
    comingSoon: 'Próximamente',
    easyMoney: 'Dinero fácil',
    content: 'Contenido',
    audience: 'Audiencia',
    view: 'Ver',
    delete: 'Eliminar',
    file: 'Archivo',
    type: 'Tipo',
    from: 'Desde',
    to: 'Hasta',
    fullName: 'Nombre completo',
    lastTimeUsed: 'Última vez utilizado',
    noMediaFiles: 'Aún no hay archivos multimedia...',
    withdraw: 'Retirar',
    congrats: '¡Felicidades!',
    makeMoneyOnline: '¡Gane dinero en línea!',
  },
  sort: {
    title: 'Ordenar',
    search: 'Buscar',
    default: 'Orden predeterminado',
    dateNew: 'Fecha: Más reciente a más antiguo',
    dateOld: 'Fecha: Más antiguo a más reciente',
    priceLow: 'Precio: De menor a mayor',
    priceHigh: 'Precio: De mayor a menor',
    nameA: 'Nombre: A a Z',
    nameZ: 'Nombre: Z a A',
    popular: 'Más populares',
  },
  emailMenu: {
    broadcasts: 'Difusiones',
    automations: 'Automatizaciones',
    templates: 'Plantillas',
    settings: 'Configuración',
    noEmails: 'Aún no hay correos electrónicos',
    newBroadcast: 'Nuevas difusiones',
  },
  aiContent: {
    title: '¡Cree su primer contenido con IA!',
    text: '¡Planifique y publique contenido en todas las redes sociales a la vez!',
    create: 'Crear contenido con IA',
  },
  pageDesign: {
    page: 'Diseño de página',
    image: 'Imagen',
  },
  toolsMenu: {
    title: 'Herramientas',
    account: 'Cuenta',
    instantPages: 'Páginas instantáneas',
    instantPagesText: 'Páginas independientes de carga rápida',
    agents: 'Agentes',
    agentsText: 'Asistentes de IA que gestionan tu perfil',
    socialPlanner: 'Planificador social',
    socialPlannerText: 'Programación e inspiración de contenido',
    emailMarketing: 'Email Marketing',
    emailMarketingText: 'Aumente su lista de contactos',
    smartReply: 'Smart Reply',
    smartReplyText: 'Envíe comentarios y mensajes automáticos',
    linkShortener: 'Acortador de enlaces',
    linkShortenerText: 'Acorte URLs largos',
    posts: 'Publicaciones',
    postsText: 'Cree y administre publicaciones',
    blog: 'Blog',
    blogText: 'Cree y administre artículos del blog',
  },
  insideMenu: {
    planner: 'Planificador',
    aiContent: 'Contenido IA',
    aiPosts: 'Publicaciones con IA',
    postIdeas: 'Ideas de publicaciones',
    contentPlanner: 'Planificador de contenido',
    aiImages: 'Imágenes con IA',
    brandProjects: 'Proyectos de marca',
    aiVideo: 'Video IA',
    integrations: 'Integraciones',
    products: 'Productos',
    orders: 'Pedidos',
    payments: 'Pagos',
    links: 'Enlaces',
    qrCodes: 'Códigos QR',
  },
  orders: {
    title: 'Pedidos',
    empty: 'Aún no tiene pedidos',
    all: 'Todos los pedidos',
    shop: 'Tienda',
    digital: 'Productos digitales',
    appointments: 'Citas',
    services: 'Servicios',
    donations: 'Donaciones',
  },
  discounts: {
    title: 'Descuentos',
    newDiscount: '+ Nuevo descuento',
    code: 'Código',
    titleCol: 'Título',
    type: 'Tipo',
    value: 'Valor',
    status: 'Estado',
    used: 'Usado',
    actions: 'Acciones',
    statusAll: 'Todos los estados',
    statusActive: 'Activo',
    statusExpired: 'Expirado',
    statusScheduled: 'Programado',
    statusInactive: 'Inactivo',
    searchPlaceholder: 'Buscar por código o título...',
    clearFilters: 'Limpiar filtros',
    emptyTitle: 'Aún no hay descuentos',
    emptySubtitle: 'Crea tu primer código promocional para ofrecer descuentos en tus productos',
    createDiscount: 'Crear descuento',
    createTitle: 'Crear descuento',
    editTitle: 'Editar descuento',
    fieldTitle: 'Título',
    fieldTitlePlaceholder: 'ej. Venta de primavera',
    fieldCode: 'Código',
    fieldCodePlaceholder: 'ej. SAVE20',
    generate: 'Generar',
    sectionDiscount: 'Descuento',
    fieldType: 'Tipo',
    typePercentage: 'Porcentaje',
    typeFixed: 'Monto fijo',
    fieldValue: 'Valor',
    sectionConditions: 'Condiciones (opcional)',
    appliesTo: 'Aplica a',
    appliesToAll: 'Todos los productos',
    appliesToShop: 'Tienda',
    appliesToDigital: 'Digital',
    appliesToCourses: 'Cursos',
    appliesToServices: 'Servicios',
    appliesToEvents: 'Eventos',
    minOrderAmount: 'Monto mínimo de pedido ($)',
    maxDiscountAmount: 'Monto máximo de descuento ($) — 0 = sin límite',
    sectionLimits: 'Límites',
    usageLimit: 'Límite total de uso — 0 = sin límite',
    usageLimitPerUser: 'Límite por cliente — 0 = sin límite',
    sectionSchedule: 'Programación',
    startDate: 'Fecha de inicio — vacío = comienza ahora',
    endDate: 'Fecha de fin — vacío = sin expiración',
    active: 'Activo',
    cancel: 'Cancelar',
    save: 'Guardar descuento',
    createdSuccess: 'Descuento creado',
    updatedSuccess: 'Descuento actualizado',
    deletedSuccess: 'Descuento eliminado',
    loadError: 'Error al cargar descuentos',
    saveError: 'Error al guardar el descuento',
    deleteError: 'Error al eliminar el descuento',
  },
  donation: {
    chooseSmiles: 'Elegir emojis',
    item: 'Elemento',
    itemTitle: 'Título del elemento de donación',
    price: 'Precio',
    thanksMessagePlaceholder: 'Muchas gracias',
    thanksMessage: 'Mensaje de agradecimiento',
    thanksMessageCaption: 'El mensaje de agradecimiento se mostrará a sus seguidores después de la donación',
    addDonation: 'Agregar donación',
    addAmount: '+ Agregar monto',
    buttonTitle: 'Título del botón',
    buttonTitleCaption: 'Título del botón de donación',
    acceptDonations: 'Aceptar donaciones',
    donationsType: 'Donaciones',
    tips: 'Propinas',
    type: 'Tipo',
    addAnotherAmount: '+ Agregar otro monto',
  },
  blog: {
    empty: 'Aún no tiene un blog',
  },
  apps: {
    empty: 'Aún no tiene aplicaciones',
  },
  payments: {
    title: 'Pagos',
    text: 'Aún no tiene transacciones',
    single: 'Pagos únicos',
    subscriptions: 'Suscripciones',
    wallet: 'Billetera',
    connectPromo: 'Conecte su cuenta de Stripe o PayPal a su página de UniLink y reciba todos los pagos en su billetera.',
    connectSystem: 'Conectar sistema de pago',
    manageCards: 'Administrar sus tarjetas',
    addNewCard: 'Agregar nueva tarjeta',
    editCard: 'Editar información de tarjeta',
    addCard: 'Agregar información de tarjeta',
    cardHolder: 'Nombre del titular de la tarjeta',
    cardHolderNecessary: 'Es necesario',
    withdrawalSuccess: '¡Su retiro se ha enviado exitosamente!',
    withdrawalError: 'Algo salió mal, intente más tarde.',
    change: 'Cambiar',
  },
  store: {
    emptyTitle: 'Aún no tiene productos',
    emptyText: 'Comience agregando su primer producto',
    emptyButton: 'Agregar producto',
    createFirstProduct: 'Cree su primer producto',
    startAdding: 'Comience agregando sus productos favoritos, bienes digitales o servicios. Un espacio donde puede vender y promocionar todo lo que ofrece.',
    activate: 'Activar tienda',
    empty: 'Aún no tiene productos',
    products: 'Productos',
    addProducts: 'Agregar productos',
    whatDoYouWant: '¿Qué desea vender?',
    externalProduct: 'URL de producto externo',
    createOwnProduct: 'Cree su propio producto',
    shop: 'Tienda',
    shopText: 'Venda productos físicos y digitales',
    digital: 'Productos digitales',
    digitalText: 'Venda una descarga digital',
    course: 'Curso o tutorial',
    courseText: 'Agregue un curso o tutorial al sitio web',
    service: 'Servicios',
    serviceText: 'Agregue servicios para sus clientes',
    appointment: 'Citas',
    appointmentText: 'Permita que los visitantes reserven tiempo en su calendario',
    event: 'Eventos o entradas',
    eventText: 'Cree un evento e invite a su audiencia',
    tips: 'Propinas',
    tipsText: 'Deje una propina a sus creadores favoritos',
    donation: 'Donaciones',
    donationText: 'Haga una donación',
    membership: 'Membresía',
    membershipText: 'Agregue una membresía al sitio web',
    links: 'Enlace externo',
    linksText: 'Agregue un enlace externo a cualquier sitio web',
    coupon: 'Cupón',
    couponText: 'Agregue un cupón para su sitio web',
    singleProduct: 'Producto único',
    singleProductText: 'Vende un único producto con un checkout sencillo',
    booking: 'Reservas',
    bookingText: 'Permite que los visitantes reserven tus espacios o propiedades',
    rental: 'Alquiler',
    rentalText: 'Publica artículos de alquiler con disponibilidad y precios',
    add: 'Agregar',
    manageStore: 'Administrar tienda',
    displayLast: 'Mostrar último producto',
  },
  products: {
    info: 'Información',
    uploadCover: 'Suba una foto de portada, luego proporcione un título y una descripción',
    thumbnail: 'Miniatura',
    thumbnailError: 'Por favor agregue una miniatura',
    title: 'Título',
    titleTooltip: 'Ingrese el nombre de su producto',
    shortDescription: 'Descripción corta',
    shortDescriptionTooltip: 'Ingrese una descripción corta de su producto',
    description: 'Descripción',
    descriptionTooltip: 'Ingrese la descripción de su producto',
    descriptionTooltipExtra: 'Descripción opcional de características del producto, tipos, color, tallas, etc.',
    price: 'Precio',
    priceTooltip: 'Ingrese el precio de su producto',
    oldPrice: 'Precio anterior',
    oldPriceTooltip: 'El precio anterior se mostrará tachado',
    category: 'Categoría',
    categoryTooltip: 'Elija la categoría de su producto',
    image: 'Imagen',
    imageTooltip: 'Suba una imagen para su producto',
    groups: 'Grupos',
    rate: 'Calificación',
    rateTooltip: 'Ingrese la calificación de su producto',
    buttonTitle: 'Título del botón',
    buttonTitleTooltip: 'Ingrese el título del botón de su producto',
    limitQuantity: 'Limitar cantidad',
    itemsLeft: 'Elementos restantes',
    itemsLeftTooltip: 'Elementos de su producto',
    attachments: 'Archivos adjuntos',
    addAttachments: 'Agregue archivos adjuntos a sus productos',
    addNewAttachment: 'Agregar nuevo elemento',
    file: 'Archivo',
    uploadFile: 'Subir archivo',
    uploadCoverTitle: 'Subir portada',
    optionalDescription: 'Descripción opcional de características del producto, tipos, color, tallas, etc.',
    customReviews: 'Reseñas personalizadas',
    addCustomReviews: 'Agregue reseñas a sus productos',
    name: 'Nombre',
    nameTooltip: 'Ingrese el nombre de su cliente',
    comment: 'Comentario',
    commentTooltip: 'Ingrese el comentario de su cliente',
    rateTooltipCustomer: 'Calificación del cliente',
    imageTooltipCustomer: 'Suba la imagen de su cliente',
    displayPriceOnPreview: 'Mostrar precio en la vista previa',
    displayDetailsOnPreview: 'Mostrar detalles en la vista previa',
    postOnSocials: 'Publicar en redes sociales',
    sendAnEmail: 'Enviar un correo electrónico',
    highlights: 'Destacados',
    listProductSetup: 'Liste el producto y configure su bloque de tienda',
    whereToSell: '¿Dónde le gustaría vender este producto?',
    youHaveProducts: 'Tiene {count} productos',
    shareThisProduct: 'Compartir este producto',
    shareAProduct: 'Compartir un producto',
    monetizeWays: 'Diferentes formas de monetizar en Unilink',
    addProductToProfile: 'Agregar un {title} a su perfil',
    productPage: 'Página del producto',
    setUpPayments: 'Configure sus pagos',
    connectPaymentMethods: 'Conecte sus métodos de pago para comenzar a ganar dinero en Unilink',
    addPaymentMethod: 'Agregue un método de pago {type} para recibir pagos de seguidores',
    withdrawAttempt: 'Este es un intento de cobro de deuda y cualquier información será utilizada con ese fin.',
    withdrawSuccess: '¡Su retiro se ha enviado exitosamente!',
    yourVisitorsPay: 'Sus visitantes pagarán primero y luego serán dirigidos a su {method}',
    emailAddress: 'dirección de correo electrónico',
    calendlyLink: 'enlace de Calendly',
  },
  posts: {
    posts: 'Publicaciones',
    title: 'Cree su primera publicación',
    description: 'Las publicaciones son donde crea automatizaciones de chat en un formato fácil y visual. Pruebe algunas automatizaciones que recomendamos según sus objetivos',
    activate: 'Activar publicaciones',
    managePosts: 'Administrar publicaciones',
    postsTab: 'Pestaña de publicaciones',
    displayLast: 'Mostrar últimas publicaciones',
    tabNavigation: 'Configuración de navegación por pestañas',
    createFirstPost: '¡Cree su primera publicación social!',
    autoPostsText: '¡Planifique y publique contenido en todas las redes sociales a la vez!',
    createPost: 'Crear publicación',
  },
  messages: {
    title: 'Mensajes',
    empty: 'Sin mensajes',
    addText: 'Agregue un botón de mensaje al bloque de encabezado, permitiendo a los usuarios enviarle un mensaje fácilmente.',
    addButton: 'Agregar botón de mensaje',
  },
  smartReply: {
    title: 'Smart Reply',
    clicks: 'clics',
    createTitle: '¡Cree su primera Smart Reply!',
    text: '¡Use los mensajes directos automáticos de Instagram para compartir enlaces con su audiencia automáticamente!',
    createButton: 'Crear Smart Reply',
  },
  shortLinks: {
    title: 'Acortador de enlaces',
    addLink: 'Agregar enlace',
    name: 'Nombre',
    slug: 'Slug',
    slugTooltip: 'Puede cambiar el slug haciendo clic en el botón de editar',
    destinationUrl: 'URL de destino',
    metadata: 'Metadatos',
    utmTags: 'Etiquetas UTM',
    customizeMetadata: 'Personalizar los metadatos del enlace',
    metaTitle: 'Título',
    metaDescription: 'Descripción',
    favicon: 'Favicon',
    imagePreview: 'Vista previa de imagen',
    addUtm: 'Agregar etiquetas UTM al enlace (opcional)',
    utmCampaign: 'UTM Campaign',
    utmMedium: 'UTM Medium',
    utmSource: 'UTM Source',
    utmTerm: 'UTM Term',
    utmContent: 'UTM Content',
    utmId: 'UTM Id',
    utmPlacement: 'UTM Placement',
    utmCreative: 'UTM Creative',
    pasteLink: 'Pegue su enlace largo aquí',
    shorten: 'Acortar enlace',
    edit: 'Editar detalles del elemento',
  },
  audience: {
    title: 'Audiencia',
    total: 'Total',
    totalMembers: 'Total de miembros de la audiencia',
    totalContacts: 'Total de contactos',
    forms: 'Formularios',
    subscribers: 'Suscriptores',
    customers: 'Clientes',
    noAudienceMembers: 'Sin contactos',
    emptyAudienceMembers: 'Agregue nuevos contactos haciendo clic en el botón',
    addAudienceMember: 'Agregar contacto',
    noSubscribers: 'Sin suscriptores',
    emptySubscribers: 'Agregue nuevos suscriptores agregando bloques a su enlace en bio',
    addDataCollect: 'Agregar bloque de recopilación de datos',
    noResponses: 'Sin respuestas',
    emptyResponses: 'Agregue nuevas respuestas agregando bloques a su enlace en bio',
    addFormBlock: 'Agregar bloque de formulario',
    noCustomers: 'Sin clientes',
    emptyCustomers: 'Agregue nuevos clientes agregando productos a su enlace en bio',
    addProduct: 'Agregar producto',
    addContactModal: {
      title: 'Agregar nuevo contacto',
      name: 'Nombre',
      nameTooltip: 'Ingrese el nombre de su contacto',
      email: 'Correo electrónico',
      emailTooltip: 'Ingrese la dirección de correo electrónico de su contacto',
      phone: 'Teléfono',
      phoneTooltip: 'Ingrese el número de teléfono de su contacto',
      telegram: 'Telegram',
      telegramTooltip: 'Ingrese el nombre de usuario o URL de Telegram de su contacto',
      whatsapp: 'WhatsApp',
      whatsappTooltip: 'Ingrese el número de WhatsApp de su contacto',
      instagram: 'Instagram',
      instagramTooltip: 'Ingrese el nombre de usuario o URL de Instagram de su contacto',
      messenger: 'Messenger',
      messengerTooltip: 'Ingrese el nombre de usuario o URL de Messenger de su contacto',
      viber: 'Viber',
      viberTooltip: 'Ingrese el número de Viber de su contacto',
      address: 'Dirección',
      addressTooltip: 'Ingrese la dirección de su contacto',
      add: 'Agregar',
    },
    search: {
      search: 'Buscar',
      error: 'Carácter no válido ingresado en el campo de búsqueda',
      notFound: 'No se encontraron resultados',
    },
  },
  auth: {
    logIn: 'Iniciar sesión',
    logInWith: 'Iniciar sesión con',
    signIn: 'Iniciar sesión',
    signInWith: 'Registrarse con',
    email: 'Correo electrónico',
    password: 'Contraseña',
    notHaveAccount: '¿No tiene una cuenta?',
    createAccount: 'Crear una nueva cuenta',
    createYourAccount: 'Cree su cuenta',
    signUp: 'Registrarse',
    haveAccount: 'Si ya tiene una cuenta',
    or: 'o',
    reset: 'Restablecer',
    resetPassword: 'Restablecer contraseña',
    resetTitle: 'El enlace de recuperación ha sido enviado a su correo electrónico',
    goToHome: 'Ir a la página de inicio',
    byClicking: 'Al hacer clic en',
    youAreAgree: 'acepta los',
    terms: 'Términos de servicio',
    andConfirm: 'y nuestra',
    usagePolicy: 'Política de uso',
    signInGoogle: 'Iniciar sesión con Google',
    forgotPassword: '¿Olvidó su contraseña?',
  },
  menu: {
    moreApps: 'Más aplicaciones',
    account: 'Cuenta',
    more: 'Más',
    storyWidget: 'Embed Stories',
    integrations: 'Integraciones',
    socialAccounts: 'Cuentas sociales',
    aiContent: 'Contenido IA',
    aiPosts: 'Publicaciones con IA',
    postIdeas: 'Ideas de publicaciones',
    contentPlanner: 'Planificador de contenido',
    aiImages: 'Imágenes con IA',
    aiVideo: 'Video con IA',
    planner: 'Planificador',
    customers: 'Clientes',
    subscribers: 'Suscriptores',
    forms: 'Formularios',
    allAudience: 'Toda la audiencia',
    payments: 'Pagos',
    orders: 'Pedidos',
    products: 'Productos',
    events: 'Eventos',
    appointments: 'Citas',
    discounts: 'Descuentos',
    instantPages: 'Páginas instantáneas',
    openInNewTab: 'Abrir en nueva pestaña',
    linkInBio: 'Enlace en bio',
    linkInBioApps: 'Enlace en bio',
    website: 'Sitio web',
    store: 'Tienda',
    audience: 'Audiencia',
    emailMarketing: 'Email Marketing',
    postPlaner: 'Planificador de publicaciones',
    posts: 'Publicaciones',
    agents: 'Agentes',
    community: 'Comunidad',
    profileHealth: 'Estado del perfil',
    socialPlanner: 'Planificador social',
    shortLinks: 'Acortador de enlaces',
    views: 'Vistas',
    clicks: 'Clics',
    allWebsites: 'Todos los sitios web',
    createNewAccount: 'Crear nueva cuenta',
    createNewWebsite: 'Crear un nuevo perfil',
    tools: 'Herramientas',
    borderGenerator: 'Generador de bordes',
    yourPlan: 'Su plan:',
    upgrade: 'Mejorar',
    accountSettings: 'Configuración de la cuenta',
    manageWebsites: 'Administrar perfiles',
    updates: 'Actualizaciones',
    autoUpdate: 'Actualización automática',
    logOut: 'Cerrar sesión',
    myPages: 'Mis páginas',
    design: 'Diseño',
    heading: 'Encabezado',
    analytics: 'Analíticas',
    settings: 'Configuración',
    open: 'Abrir',
    language: 'Idioma',
    movePage: 'Mover página',
    editBlock: 'Editar bloque',
    renameBlock: 'Renombrar bloque',
    rename: 'Renombrar',
    deleteBlock: 'Eliminar bloque',
    archiveBlock: 'Archivar bloque',
    archive: 'Archivar',
    scheduleBlock: 'Programar bloque',
    copyBlock: 'Copiar bloque',
    dublicateBlock: 'Duplicar bloque',
    content: 'Contenido',
    preview: 'Vista previa',
    copy: 'Copiar',
    moveBlock: 'Mover bloque',
    move: 'Mover',
    edit: 'Editar',
    delete: 'Eliminar',
    schedule: 'Programar',
    dublicate: 'Duplicar',
    smartReply: 'Smart Reply',
    marketing: 'Marketing',
    selectBlocks: 'Seleccionar bloques',
    selectAll: 'Seleccionar todo',
    cancelSelection: 'Cancelar',
    blocksSelected: 'seleccionados',
    moveToPage: 'Mover a la página',
    newPage: 'Nueva página',
    openPage: 'Abrir página',
    pageSettings: 'Ajustes de página',
    deletePage: 'Eliminar página',
    appInBio: 'App en bio',
    blog: 'Blog',
    publish: 'Publicar',
    creatorHub: 'Centro de creadores',
    qrCodes: 'Códigos QR',
    apps: 'Apps',
    automations: 'Automatizaciones',
    messages: 'Bandeja de entrada',
    form: 'Formularios',
    embedTools: 'Embed Tools',
  },
  modal: {
    addInstagram: 'Agregar Instagram',
    addYourInstagram: 'Agregue su cuenta de Instagram',
    cropYourAvatar: 'Recorte su avatar',
    removeSite: '¿Está seguro de que desea eliminar el sitio?',
    areYouSure: '¿Está seguro de que desea',
    areYouSureDelete: '¿Está seguro de que desea eliminar esta sección?',
    areYouSureArchive: '¿Está seguro de que desea archivar este bloque?',
    areYouSurePermanentDelete: '¿Está seguro de que desea eliminar permanentemente este bloque? Esta acción no se puede deshacer.',
    remove: 'eliminar',
    site: 'sitio',
    removeAccountText: 'eliminar su cuenta',
    moveBlock: 'Mover bloque a otra página',
    moveBlockText: 'Esto moverá el bloque al final de otra página. Luego puede reorganizar el bloque en la nueva página',
    profileTitle: 'Cambiar foto de perfil',
    profileText: 'Elija una imagen o GIF desde su dispositivo.',
    profileAvatar: 'Avatar de perfil',
    addProfilePicture: 'Agregar foto de perfil',
    storiesTitle: 'Historias',
    storiesText: 'Comparta sus momentos cotidianos.',
    thoughtsTitle: 'Pensamientos',
    thoughtsText: 'Comparta sus pensamientos.',
    accountPageDescription: 'Esta es su página de cuenta, donde puede personalizar cómo se ve su página, agregar diferentes bloques de funciones y más.',
  },
  modalSubscribe: {
    plan: 'Plan',
    usdMonth: 'USD/mes',
    sites: 'Sitios',
    sitesMuch: 'Sitios',
    notification: 'Notificaciones',
    noNotification: 'Aún no hay notificaciones',
    inCategory: 'No hay elementos en la categoría',
    categoryYet: 'aún.',
    externalPixels: 'Píxeles externos',
    parameters: 'parámetros',
    analyticsReports: 'Analíticas e informes',
    noUniLinkLogo: 'Sin logo de UniLink',
    inProfile: 'en el perfil',
    verifiedBadge: 'Insignia verificada',
    your: 'Su',
    customDomain: 'dominio personalizado',
    emailMarketing: 'Email Marketing',
    liveSupport: 'Soporte en vivo',
    dataSecured: 'Los datos están protegidos conforme al estándar PCI DSS',
    thankYou: 'Gracias por su interés. Nos pondremos en contacto con usted pronto.',
    socialMediaScheduler: 'Programador de redes sociales',
    featureRequest: 'Solicitud de función',
    markAllRead: 'Marcar todo como leído',
    currentPlan: 'Plan actual',
    features: 'Características',
  },
  buttons: {
    upgrade: 'Mejorar plan',
    buyProPlan: 'Comprar plan Pro',
    continue: 'Continuar',
    skip: 'Omitir',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    back: 'Atrás',
    save: 'Guardar',
    add: 'Agregar',
    added: 'Agregado',
    done: 'Listo',
    ok: 'OK',
    edit: 'Editar',
    delete: 'Eliminar',
    remove: 'Eliminar',
    setAsDefault: 'Establecer como predeterminado',
    subscribeNow: 'Suscribirse ahora',
    yes: 'Sí',
    preview: 'Vista previa',
    generate: 'Generar',
    changePassword: 'Cambiar contraseña',
    deleteAccount: 'Eliminar cuenta',
    removeAccount: 'Eliminar cuenta',
    deleteProfile: 'Eliminar perfil',
    addBlock: 'Agregar bloque',
    copyLink: 'Copiar enlace',
    active: 'Activo',
    update: 'Actualizar',
    updatePro: 'Mejorar plan',
    prev: 'Anterior',
    next: 'Siguiente',
    uploadImage: 'Subir imagen',
    uploadVideo: 'Subir video',
    loadMore: 'Cargar más',
    uploadProductImage: 'Subir imagen del producto',
    claim: 'Reclamar',
    removeSite: 'Eliminar sitio',
    move: 'Mover',
    addButton: 'Agregar botón',
    actionButton: 'Botón de acción',
    directMessage: 'Mensaje directo',
    subscribe: 'Suscribirse',
    button: 'Botón',
    generateWithAI: 'Generar con IA',
    cta: 'CTA',
    cart: 'Carrito',
    direct: 'Directo',
    follow: 'Seguir',
    addNewItem: 'Agregar nuevo elemento',
  },
  support: {
    liveSupport: 'Soporte en vivo',
    response: 'Generalmente respondemos en 1 minuto durante el horario laboral (8AM - 10PM) GMT+3',
    founder: 'Denys Bilozor',
    ceo: 'Fundador y CEO en UniLink',
  },
  wizard: {
    createNewProfile: 'Crear un nuevo perfil',
    createProfile: 'Crear perfil',
    continue: 'Continuar',
    tellUs: 'Cuéntenos sobre usted',
    addSocialLinks: 'Agregue todas las redes sociales y las mostraremos en su base de datos',
    addMoreLinks: 'Agregar más enlaces',
    addLink: 'Agregar enlace',
    selectCategory: 'Seleccione una categoría que mejor lo describa:',
    chooseTemplate: 'Elija una plantilla',
    skip: 'Omitir',
    step: 'Paso',
    of: 'de',
    yourName: 'Su nombre',
    search: 'Buscar',
    blog: 'Blog',
    creator: 'Creador',
    music: 'Música',
    events: 'Eventos',
    esoteric: 'Esotérico',
    fashion: 'Moda',
    influencer: 'Influencer',
    food: 'Comida',
    smallBusiness: 'Pequeña empresa',
    marketing: 'Marketing',
    education: 'Educación',
    socialMedia: 'Redes sociales',
    coaching: 'Coaching',
    ecommerce: 'Comercio electrónico',
    healthAndFitness: 'Salud y fitness',
    beautyWellness: 'Belleza y bienestar',
  },
  billing: {
    back: 'Atrás',
    findPlan: 'Encuentre el plan para usted',
    changeAnytime: 'Puede cambiar en cualquier momento.',
  },
  field: {
    fullName: 'Nombre completo',
    username: 'nombre de usuario',
    addValue: 'Agregar valor',
    newValue: 'Nuevo valor',
    placeholderDefault: 'Texto, números, símbolos, etc.',
    addInstagramUsername: 'Agregar nombre de usuario de Instagram',
    nameDefault: 'Juan',
    enterYourLink: 'Ingrese su enlace',
    searchImage: 'Buscar imagen',
    pasteLink: 'Pegar enlace',
    pasteLinkTip: 'Agregue un enlace a cualquier página web',
    searchGIFs: 'Buscar GIFs',
    searchIcons: 'Buscar íconos',
    searchVideo: 'Buscar video',
    search: 'Buscar',
    insertURL: 'Insertar URL',
    writeYourDescription: 'Escriba su descripción',
    headerCTAbutton: 'Encabezado, botón CTA',
    enterTitle: 'Ingrese el título',
    enterDescription: 'Ingrese la descripción',
    enterURL: 'Ingrese la URL canónica',
  },
  tooltip: {
    addImage: 'Agregar imagen',
    labelModalTitle: 'Configuración de etiqueta',
    addLabel: '+ Agregar etiqueta',
    label: 'Etiqueta',
    labelCaption: 'Ingrese la etiqueta',
    labelText: 'Texto de la etiqueta',
    labelTextCaption: 'Ingrese el texto de la etiqueta',
    labelTextPlaceholder: 'Etiqueta',
    labelUrl: 'URL de la etiqueta',
    labelUrlCaption: 'Ingrese la URL de la etiqueta',
    labelUrlPlaceholder: 'https://example.com',
    noLabel: 'Sin etiqueta',
    colorFrom: 'Color desde',
    colorTo: 'Color hasta',
    highlight: 'Destacar',
    firstName: 'Nombre',
    firstNameCaption: 'Ingrese su nombre',
    lastName: 'Apellido',
    lastNameCaption: 'Ingrese su apellido',
    jobTitle: 'Puesto de trabajo',
    jobTitleCaption: 'Ingrese su puesto de trabajo',
    organization: 'Organización',
    organizationCaption: 'Ingrese su organización',
    email: 'Correo electrónico',
    emailCaption: 'Ingrese su correo electrónico',
    workPhone: 'Teléfono de trabajo',
    workPhoneCaption: 'Ingrese su teléfono de trabajo',
    mobilePhone: 'Teléfono móvil',
    mobilePhoneCaption: 'Ingrese su teléfono móvil',
    website: 'Sitio web',
    websiteCaption: 'Ingrese su sitio web',
    information: 'Información',
    informationCaption: 'Ingrese su información',
    streetAddress: 'Dirección',
    streetAddressCaption: 'Ingrese su dirección',
    city: 'Ciudad',
    cityCaption: 'Ingrese su ciudad',
    state: 'Estado',
    stateCaption: 'Ingrese su estado',
    postalCode: 'Código postal',
    postalCodeCaption: 'Ingrese su código postal',
    country: 'País',
    countryCaption: 'Ingrese su país',
    titleColor: 'Color del título',
    titleColorCaption: 'Puede cambiar el color del título',
    fontFamily: 'Familia tipográfica',
    fontFamilyCaption: 'Puede cambiar la familia tipográfica',
    fontSize: 'Tamaño de fuente',
    fontSizeLabel: 'Tamaño de fuente de la etiqueta',
    fontSizeCaption: 'Puede cambiar el tamaño de fuente',
    fontSelect: 'Fuente',
    fontSelectCaption: 'Elija una fuente',
    imageMargin: 'Margen de imagen',
    profilePicture: 'Foto de perfil',
    profilePictureCaption: 'Cambie su foto de perfil',
    pictureSize: 'Tamaño de la imagen',
    pictureSizeCaption: 'Puede cambiar el tamaño de la imagen',
    title: 'Título',
    titleCaption: 'Ingrese un título',
    blockCaption: 'Ingrese un título para su bloque',
    titlePageCaption: 'Ingrese un título para su página',
    templates: 'Plantillas',
    templatesCaption: 'Elija una plantilla para su página',
    background: 'Fondo',
    backgroundColor: 'Color de fondo',
    textBackground: 'Fondo del texto',
    textBackgroundCaption: 'Elige el color de fondo del texto',
    textColor: 'Color del texto',
    textColorCaption: 'Elige el color del texto',
    gradientBackground: 'Fondo degradado',
    gradientColor: 'Color degradado',
    BackgroundType: 'Tipo',
    backgroundSource: 'Fuente del fondo',
    backgroundSourceCaption: 'Elija la fuente del fondo',
    backgroundStyle: 'Estilo del fondo',
    backgroundStyleCaption: 'Elija el estilo del fondo',
    backgroundStylesNormal: 'Normal',
    backgroundStylesGlass: 'Cristal',
    backgroundStylesOutline: 'Contorno',
    backgroundTypeCaption: 'Elija el tipo de fondo',
    color: 'Color',
    colorTooltip: 'Puede cambiar el color',
    backgroundOpacityTooltip: 'Arrastre el control deslizante para establecer la opacidad del fondo',
    backgroundBlur: 'Desenfoque del fondo',
    backgroundBlurCaption: 'Arrastre el control deslizante para desenfocar el fondo',
    backgroundBrightness: 'Brillo del fondo',
    backgroundBrightnessCaption: 'Arrastre el control deslizante para cambiar el brillo del fondo',
    backgroundContrast: 'Contraste del fondo',
    backgroundContrastCaption: 'Arrastre el control deslizante para cambiar el contraste del fondo',
    color1: 'Color 1',
    color2: 'Color 2',
    colorCaption: 'Ingrese el color de su página',
    gradient: 'Degradado',
    image: 'Imagen',
    photo: 'Foto',
    gif: 'GIF',
    animation: 'Animación',
    video: 'Video',
    hexColor: 'Color hexadecimal',
    direction: 'Dirección',
    gradientDirection: 'Dirección del degradado',
    directionCaption: 'Arrastre el control deslizante para establecer la dirección del degradado',
    offset: 'Desplazamiento',
    gradientOffset: 'Desplazamiento del degradado',
    offsetCaption: 'Arrastre el control deslizante para establecer el desplazamiento del degradado',
    backgroundDarkness: 'Oscuridad del fondo',
    backgroundDarknessCaption: 'Arrastre el control deslizante para oscurecer la imagen de fondo',
    uploadVideo: 'Subir video',
    uploadFile: 'Subir archivo',
    uploadVideoCaption: 'Video del fondo de su página',
    linkToVideo: 'Enlace al video',
    linkToVideoCaption: 'Agregue un enlace al video',
    videoWithSound: 'Video con sonido',
    videoWithSoundCaption: 'Reproducir video con sonido',
    fonts: 'Fuentes',
    fontWeight: 'Peso de fuente',
    fontWeightCaption: 'Haga clic para elegir su destino',
    preloader: 'Precargador',
    preview: 'Vista previa',
    hideLogo: 'Ocultar logo de UniLink',
    cover: 'Portada',
    coverCaption: 'Cambiar portada',
    coverCaptionHeader: 'Agregar imagen o video a la portada del encabezado',
    pageNavigation: 'Navegación de página',
    websiteNavigation: 'Navegación por pestañas',
    backgroundOpacity: 'Opacidad del fondo',
    backgroundOpacityCaption: 'Arrastre el control deslizante para cambiar la opacidad del fondo del botón',
    borderRadius: 'Radio del borde',
    borderRadiusCaption: 'Arrastre el control deslizante para establecer el radio del borde',
    heightTabs: 'Altura de pestañas',
    heightTabsCaption: 'Arrastre el control deslizante para establecer la altura de las pestañas',
    backgroundShadow: 'Sombra del fondo',
    backgroundShape: 'Forma del fondo',
    backgroundBorder: 'Borde del fondo',
    opacity: 'Opacidad',
    opacityCaption: 'Arrastre el control deslizante para establecer la opacidad',
    shape: 'Forma',
    shapeCaption: 'Establecer forma',
    text: 'Texto',
    textCaption: 'Ingrese texto',
    textSize: 'Tamaño del texto',
    textSizeCaption: 'Arrastre el control deslizante para establecer el tamaño del texto',
    additionalText: 'Texto adicional',
    username: 'Nombre de usuario',
    currency: 'Moneda',
    language: 'Idioma',
    timeZone: 'Zona horaria',
    websiteNiche: 'Nicho del sitio web',
    websiteNicheCaption: 'Ingrese el nicho de su sitio web',
    renameCaption: 'Renombrar título del bloque',
    description: 'Descripción',
    descriptionCaption: 'Ingrese una descripción',
    actionButton: 'Botón de acción',
    actionButtonCaption: 'El botón de llamada a la acción motiva a los visitantes a tomar acción',
    animationDirection: 'Dirección de la animación',
    animationDirectionCaption: 'Elija la dirección de la animación',
    buttonTitle: 'Título del botón',
    buttonTitleCaption: 'Ingrese el título del botón',
    buttonUrl: 'URL del botón',
    buttonUrlCaption: 'La URL se abrirá en una nueva ventana',
    imageSize: 'Tamaño de imagen',
    imageSizeCaption: 'Arrastre el control deslizante para establecer el tamaño de la imagen',
    view: 'Vista',
    viewCaption: 'Elija una vista',
    margin: 'Margen',
    marginCaption: 'Arrastre el control deslizante para agregar margen arriba y abajo del elemento',
    separateTopBottom: 'Arriba / Abajo',
    padding: 'Relleno',
    paddingCaption: 'Arrastre el control deslizante para agregar relleno arriba y abajo del elemento',
    fullWidth: 'Ancho completo',
    lineHeight: 'Altura de línea',
    lineHeightCaption: 'Puede cambiar la altura de línea',
    button: 'Botón',
    titleSize: 'Tamaño del título',
    titleSizeCaption: 'Puede cambiar el tamaño del título',
    titleLineHeight: 'Altura de línea del título',
    titleLineHeightCaption: 'Personalice la altura de línea del título para aportar más soluciones de diseño al texto',
    layout: 'Diseño',
    layoutCaption: 'Cree el diseño de encabezado que desee',
    layoutAlign: 'Alineación del diseño',
    alignText: 'Alinear texto',
    align: 'Alinear',
    alignCaption: 'Elija la alineación',
    position: 'Posición',
    positionCaption: 'Elija la posición',
    width: 'Ancho',
    widthCaption: 'Elija el ancho de su banner',
    nameHeader: 'Nombre (dejar vacío para restablecer)',
    nameCaption: 'Ingrese el nombre de su cuenta',
    shortBio: 'Biografía corta',
    shortBioCaption: 'Ingrese la biografía corta de su cuenta',
    externalLink: 'Enlace externo',
    externalLinkCaption: 'Ingrese el enlace externo a su cuenta',
    location: 'Ubicación',
    locationCaption: 'Ingrese su ubicación',
    locationMap: 'Mapa de ubicación',
    locationMapCaption: 'Ingrese la URL de su ubicación',
    rightIcon: 'Ícono derecho',
    rightIconCaption: 'Este ícono aparecerá en el lado derecho del botón',
    buttons: 'Botones',
    buttonsCaption: 'Agregar botones de acción',
    nameLogo: 'Logo del nombre',
    nameLogoCaption: 'Suba un logo para su nombre',
    buttonText: 'Texto del botón',
    buttonTextCaption: 'Ingrese el nombre de su botón',
    buttonColor: 'Color del botón',
    buttonColorCaption: 'Elija colores para el botón',
    buttonColorCTACaption: 'Elija el color de fondo para el botón CTA',
    cartColor: 'Color del carrito',
    cartColorCaption: 'Elija el color de fondo para el carrito',
    ctaButton: 'Botón CTA',
    ctaButtonCaption: 'Este ícono aparecerá en el lado derecho del botón',
    style: 'Estilo',
    socialIconsStyleCaption: 'Puede elegir el estilo de sus íconos sociales',
    socialIconsShape: 'Forma de íconos sociales',
    socialIconsShapeCaption: 'Puede elegir la forma de los íconos sociales',
    headerTextColorCaption: 'Puede elegir el color del texto del encabezado',
    pictureShape: 'Forma de la imagen',
    pictureShapeCaption: 'Puede elegir la forma de la foto de perfil',
    socialLinks: 'Enlaces sociales',
    socialLinksCaption: 'Agregue botones de enlaces sociales para una conexión rápida entre usted y sus clientes con un solo clic',
    URL: 'URL',
    URLCaption: 'Ingrese la dirección URL',
    heading: 'Encabezado',
    headingTitle: 'Título del encabezado',
    headingTitleCaption: 'Ingrese el título del encabezado',
    headingDescription: 'Descripción del encabezado',
    headingDescriptionCaption: 'Ingrese la descripción del encabezado',
    headingImage: 'Imagen del encabezado',
    headingImageCaption: 'Suba una imagen para su encabezado',
    headingPosition: 'Posición del encabezado',
    headingInsideBlock: 'Dentro del bloque',
    headingOutsideBlock: 'Fuera del bloque',
    headingDivider: 'Divisor del encabezado',
    canonicalURL: 'URL canónica',
    seo: 'SEO',
    seoCaption: 'Personalice su producto con etiquetas meta SEO',
    themes: 'Temas',
    brandColors: 'Colores de marca',
    applyBrandColors: 'Aplicar al perfil',
    syncBlocks: 'Sincronizar todos los bloques',
    brandColorsApplied: 'Colores de marca aplicados',
    generatedPalette: 'Paleta generada',
    applying: 'Aplicando...',
    syncing: 'Sincronizando...',
    backgroundType: 'Tipo de fondo',
    palettes: 'Paletas',
    previewTitle: 'Título',
    previewTitleCaption: 'Ingresa el título de la vista previa',
    previewDescription: 'Descripción',
    previewDescriptionCaption: 'Ingresa la descripción de la vista previa',
    previewButton: 'Texto del botón',
    previewButtonCaption: 'Ingresa el texto del botón de la vista previa',
    previewLabel: 'Texto de la etiqueta',
    previewLabelCaption: 'Ingresa el texto de la etiqueta de la vista previa',
    previewThumbnail: 'Miniatura',
    previewThumbnailCaption: 'Sube la miniatura de la vista previa',
  },
  table: {
    clicks: 'Clics',
    signups: 'Registros',
    views: 'Impresiones',
    orderNumber: 'Número de pedido',
    amount: 'Monto',
    credits: 'Créditos',
    invoice: 'Factura',
    email: 'Correo electrónico',
    card: 'Tarjeta',
    currency: 'Moneda',
    name: 'Nombre',
    contact: 'Contacto',
    optIn: 'Suscripción',
    notes: 'Notas',
    address: 'Dirección',
    date: 'Fecha',
    action: 'Acción',
    custom: 'Personalizado',
    status: 'Estado',
    tags: 'Etiquetas',
    view: 'Ver',
    remove: 'Eliminar',
    sendEmail: 'Enviar correo electrónico',
    details: 'Detalles',
    purchases: 'Compras',
    order: 'Pedido',
    money: 'Dinero',
    type: 'Tipo',
    orderCode: 'Código de pedido',
  },
  settings: {
    title: 'Configuración',
    settings: 'configuración',
    accountSettings: 'Configuración de la cuenta',
    email: 'Correo electrónico',
    subscription: 'Suscripción',
    billingHistory: 'Historial de facturación',
    dueTo: 'Vigente hasta',
    subscriptionDueTo: 'Suscripción vigente hasta',
    cancelSubscription: 'Cancelar suscripción',
    cancelSubscriptionConfirm: '¿Está seguro de que desea cancelar su suscripción?',
    subscriptionCancelled: 'Su suscripción ha sido cancelada. Su plan permanecerá activo hasta el final del período de facturación.',
    subscriptionCancelError: 'No se pudo cancelar la suscripción. Contacte con soporte.',
    deleteFirst: 'Eliminar permanentemente su',
    deleteSecond: 'y todos sus datos. Esta acción no se puede deshacer.',
    account: {
      title: 'Cuenta',
      usernameNotAvailable: 'El nombre de usuario no está disponible',
      setupCustomDomain: 'Configurar dominio personalizado',
      subtitle: 'Correo electrónico de la cuenta, facturación, contraseña y API Key',
    },
    profile: {
      title: 'Perfil',
      usernameNotAvailable: 'El nombre de usuario no está disponible',
      setupCustomDomain: 'Configurar dominio personalizado',
      subtitle: 'Administrar nombre de usuario, idioma, moneda, zona horaria',
      category: 'Categoría',
      categoryCaption: 'Ingrese la categoría de su perfil',
    },
    aiassistant: {
      title: 'Asistente IA',
      subtitle: 'Personalice su asistente de IA para obtener respuestas mejores y más personalizadas',
      titleText: 'Ayude a la IA a entender quién es usted para obtener respuestas más relevantes',
      customAiTitle: 'Instrucciones personalizadas',
      customAiPlaceholder: 'Agregue instrucciones específicas para la IA...',
      customAiDescription: 'Estas instrucciones se aplicarán a cada conversación con la IA',
      nicknameTitle: '¿Cómo debería llamarle la IA?',
      nicknamePlaceholder: 'Apodo',
      titleBio: 'Biografía / Descripción',
      bioPlaceholder: 'Cuéntenos un poco sobre usted...',
      occupation: '¿A qué se dedica?',
      occupationPlaceholder: 'ej. Estudiante de ingeniería en la Universidad de Waterloo',
      aboutYouTitle: 'Sobre usted',
      aboutYouTooltip: 'Cuéntele a su asistente de IA un poco sobre usted',
      locationTitle: 'Ubicación',
      locationPlaceholder: 'ej. Madrid, España',
      categoryTitle: 'Categoría',
    },
    notifications: {
      title: 'Notificaciones',
      subtitle: 'Configure notificaciones sobre nuevos visitantes, correos electrónicos y pedidos',
      text: 'Conecte mensajeros para recibir notificaciones sobre nuevos correos electrónicos y pedidos de clientes',
      setUpWebhooks: 'Configure webhooks en la sección de Webhooks',
      save: 'Guardar',
      connect: 'CONECTAR',
      disconnect: 'DESCONECTAR',
      webhook: 'Webhook',
      emailSubmit: 'Envío de recopilación de datos',
      formSubmit: 'Envío de formulario',
      showSubmit: 'Envío de tienda',
      digitalSubmit: 'Envío digital',
      appointmentSubmit: 'Envío de cita',
      requestSubmit: 'Envío de servicio',
      donationSubmit: 'Envío de donación',
      email: 'Correo electrónico',
      settings: 'configuración',
      cartSubmit: 'Envío de carrito',
      linkClick: 'Clic en enlace',
      contactClick: 'Clic en contacto',
      all: 'Todos',
      updates: 'Actualizaciones',
      messages: 'Mensajes',
      opportunities: 'Oportunidades',
      insights: 'Información',
      activity: 'Actividad',
      system: 'Sistema',
      news: 'Noticias',
      more: 'Mostrar más',
      less: 'Mostrar menos',
      connectedAccounts: 'Cuentas conectadas',
      addEmailAccount: 'Agregar cuenta de correo electrónico',
    },
    paymentSystem: {
      title: 'Sistema de pago',
      subtitle: 'Configure los pagos a través de Stripe o PayPal',
      text: 'Ver tarifas de procesamiento',
      connected: 'Conectado',
      active: 'Aceptar pagos en el sitio web',
      pending: 'Pendiente',
      disconnect: 'Desconectar',
      connect: 'Conectar',
      add: 'Agregar',
      ofYourAccount: 'de su cuenta',
      save: 'Guardar',
    },
    shop: {
      title: 'Tienda',
      subtitle: 'Configurar categoría y propiedad',
      label: {
        title: 'Etiquetas',
        subtitle: 'Agregar etiquetas a las tarjetas de productos',
        addValue: 'Agregar valor',
        save: 'Guardar',
        value: 'Valor',
        enterTitle: 'Ingrese el título',
        maximum: 'El número máximo de valores es 5',
        add: 'Agregar',
        edit: 'Editar',
        labels: 'Etiquetas',
      },
      category: {
        title: 'Categorías',
        subtitle: 'Agregar categoría a sus productos',
        addCategory: 'Agregar categoría',
        save: 'Guardar',
        maximum: 'El número máximo puede ser',
      },
      property: {
        title: 'Propiedad',
        subtitle: 'Agregar propiedad a sus productos',
        addProperties: 'Agregar propiedades',
        properties: 'Propiedades',
        type: 'Tipo',
        typeTooltip: 'Tipo de sus propiedades',
        titleModal: 'Título',
        titleModalTooltip: 'Nombre de sus propiedades',
        enterTitle: 'Ingrese el título',
        value: 'Valor',
        addValue: 'Agregar valor',
        maximum: 'El número máximo de valores puede ser',
        save: 'Guardar',
        cancel: 'Cancelar',
        remove: 'Eliminar',
        addPropertyToItem: 'Agregar propiedad al elemento',
        add: 'Agregar',
        edit: 'Editar',
        propertiesSmall: 'propiedades',
        required: 'Obligatorio',
        requiredTooltip: 'Establecer propiedades obligatorias para la compra',
        selectAll: 'Seleccionar todo',
      },
      preorderForm: {
        title: 'Formulario de preorden',
        subtitle: 'Configurar campos del formulario de preorden',
        fields: 'Campos',
        fieldsTooltip: 'Agregar campos al formulario',
        required: 'Obligatorio',
        submitButton: 'Título del botón de envío',
        redirectUrl: 'URL de redirección (opcional)',
        resultText: 'Texto del resultado',
        save: 'Guardar',
        name: 'Nombre',
        emailAddress: 'Dirección de correo electrónico',
        phone: 'Teléfono',
        address: 'Dirección',
        comment: 'Comentario',
      },
      shipping: {
        title: 'Envío',
        subtitle: 'Configurar campos de envío',
        fields: 'Campos',
        fieldsTooltip: 'Agregar campos al formulario de envío',
        required: 'Obligatorio',
        save: 'Guardar',
        name: 'Nombre',
        emailAddress: 'Dirección de correo electrónico',
        phone: 'Teléfono',
        address: 'Dirección',
        comment: 'Comentario',
        addCustomField: 'Agregar campo personalizado',
        addFormInfo: 'Agregar información del formulario',
        editFormInfo: 'Editar información del formulario',
        type: 'Tipo',
        typeTooltip: 'Tipo de campo personalizado',
        fieldName: 'Nombre del campo',
        fieldNameTooltip: 'Nombre para el campo personalizado',
        placeholder: 'Placeholder',
        placeholderTooltip: 'Placeholder para el campo personalizado',
        delete: 'Eliminar',
        update: 'Actualizar',
        add: 'Agregar',
      },
    },
    seo: {
      title: 'SEO',
      subtitle: 'Personalice su página con etiquetas meta SEO',
      titleText: 'Título',
      titlePlaceholder: 'Ingrese el título de la página',
      description: 'Descripción',
      descriptionPlaceholder: 'Ingrese la descripción de la página',
      favicon: 'Favicon',
      uploadFavicon: 'Subir favicon',
      imagePreview: 'Vista previa de imagen',
      useCustom: 'Usar imagen personalizada',
      save: 'Guardar',
      visualise: 'Visualice cómo se verá la vista previa de su sitio web en Google',
      inMessengers: 'En mensajeros',
      inSocial: 'En redes sociales',
      searchEngine: 'Motor de búsqueda',
      googleIndexable: 'Indexable por Google',
    },
    analytics: {
      title: 'Analíticas',
      subtitle: 'Integre Facebook Pixel, Google Analytics y parámetros UTM',
      facebookTooltip: 'Conecte Facebook para mostrar analíticas',
      googleAnalyticsTooltip: 'Google Analytics le permite medir el ROI de su publicidad y rastrear todos sus enlaces.',
      googleTagManagerTooltip: 'Google Tag Manager le permite configurar e implementar etiquetas en su sitio web al instante',
      tikTokPixelTooltip: 'El pixel de TikTok es una poderosa herramienta de medición que rastrea el impacto de sus anuncios de TikTok en su sitio web',
      pinterestTag: 'Etiqueta de Pinterest',
      pinterestTagTooltip:
        'La etiqueta de Pinterest es un fragmento de código que agrega a su sitio web que permite a Pinterest rastrear a los visitantes de su sitio, así como las acciones que realizan después de ver su anuncio de Pinterest.',
      tag: 'etiqueta',
      headerTagTooltip: 'Pegue la etiqueta que aparece en el encabezado de su sitio web',
      bodyTagTooltip: 'Pegue la etiqueta que aparece en el cuerpo de su sitio web',
      utmParameters: 'Parámetros UTM',
      utmParametersTooltip: 'Recopile datos de campaña con URLs personalizadas. Agregue parámetros a las URLs para identificar las campañas que generan tráfico.',
      makeAnalytics: 'Hacer que Google Analytics muestre el tráfico de UniLink como Social',
      the: 'El',
      campaign: 'parámetro de campaña',
      parameter: 'se establece dinámicamente desde el título de cada publicación o enlace',
      save: 'Guardar',
    },
    customDomain: {
      title: 'Dominio personalizado',
      subtitle: 'Personalice su página con un dominio personalizado',
      titleTooltip: 'Agregar dominio personalizado',
      save: 'Guardar',
      connect: 'Conectar',
      connecting: 'Conectando',
      instructions: 'Instrucciones',
      submit: 'Enviar',
      submitting: 'Enviando...',
      enterDomain: 'Ingrese su dominio',
      domainPlaceholder: 'su-dominio.com',
      steps: {
        submitting: 'Enviando solicitud',
        validation: 'Validación del dominio',
        certificate: 'Provisión del certificado',
        complete: 'Completado',
      },
      txtRecord: {
        title: 'Registro TXT',
        description: 'Agregue el siguiente registro TXT a su configuración DNS:',
        verifyButton: 'Verificar registro TXT',
        verifying: 'Verificando...',
        verified: 'Registro TXT verificado',
      },
      cnameRecord: {
        title: 'Registro CNAME',
        description: 'Agregue el siguiente registro CNAME a su configuración DNS:',
        verifyButton: 'Verificar registro CNAME',
        verifying: 'Verificando...',
        verified: 'Registro CNAME verificado',
      },
      dnsTable: {
        type: 'Tipo',
        host: 'Host',
        value: 'Valor',
        ttl: 'TTL',
        copy: 'Copiar',
        copied: '¡Copiado!',
      },
      provisioning: {
        title: 'El certificado SSL se está provisionando...',
        description: 'Esto puede tardar unos minutos. Por favor espere.',
        timeout: 'La provisión del certificado está tardando más de lo esperado. Vuelva a verificar más tarde.',
      },
      complete: {
        title: 'HTTPS ha sido habilitado exitosamente en su dominio.',
        connected: 'Conectado',
      },
      failed: {
        title: 'La conexión del dominio falló',
        tryAgain: 'Intentar de nuevo',
      },
      rootDomainWarning: 'Los dominios raíz requieren que su proveedor DNS soporte aplanamiento de CNAME (ej. Cloudflare, Route53).',
      deleteConfirm: {
        title: 'Desconectar dominio',
        message: '¿Está seguro de que desea desconectar este dominio? Su sitio web ya no será accesible a través de este dominio.',
        confirm: 'Desconectar',
        cancel: 'Cancelar',
      },
    },
    webhooks: {
      title: 'Webhooks',
      subtitle: 'Envíe notificaciones de eventos en tiempo real a servicios externos',
      webhook: 'Webhook',
      webhookTooltip: 'Agregar webhook',
      send: 'Enviar eventos a sitios web de terceros',
      webhookUrl: 'URL del webhook (solicitud POST)',
      error: 'Ingrese un enlace correcto',
      save: 'Guardar cambios',
      enableWebhooks: 'Habilitar Webhooks',
      enableDescription: 'Solicitudes POST en eventos seleccionados',
      endpointUrl: 'URL del endpoint',
      endpointTooltip: 'La URL que recibirá solicitudes POST cuando ocurran los eventos seleccionados',
      endpointPlaceholder: 'https://example.com/api/webhook',
      events: 'Eventos',
      selectAll: 'Seleccionar todo',
      deselectAll: 'Deseleccionar todo',
      filterPlaceholder: 'Filtrar eventos...',
      all: 'Todos',
      none: 'Ninguno',
      active: 'Activo',
      inactive: 'Inactivo',
      categories: {
        submissions: 'Envíos',
        engagement: 'Interacción',
      },
      eventLabels: {
        SubmitHeaderSubscribe: 'Suscripción en encabezado',
        SubmitHeaderMessage: 'Mensaje en encabezado',
        SubmitDataCollect: 'Recopilación de datos',
        SubmitForm: 'Envío de formulario',
        SubmitShop: 'Pedido de tienda',
        SubmitShopPreorder: 'Preorden de tienda',
        SubmitDigital: 'Producto digital',
        SubmitAppointment: 'Cita',
        SubmitService: 'Pedido de servicio',
        SubmitEvent: 'Registro de evento',
        SubmitCourse: 'Inscripción a curso',
        SubmitDonation: 'Donación',
        SubmitMembership: 'Membresía',
        SubmitBlog: 'Compra de blog',
        SubmitCoupon: 'Cupón utilizado',
        SubmitTip: 'Propina',
        SubmitLink: 'Compra de enlace',
        SubmitProductMessage: 'Pregunta sobre producto',
        SubmitPodcast: 'Compra de podcast',
        SubmitBooking: 'Reserva',
        SubmitRental: 'Alquiler',
        SubmitSingleProduct: 'Producto individual',
        SubmitDiscount: 'Pedido con descuento',
        SubmitListing: 'Solicitud de listado',
        SubmitUnlock: 'Desbloqueo de contenido',
        SubmitChatAi: 'Mensaje de chat IA',
        ClickLink: 'Clic en enlace',
        ClickContact: 'Clic en contacto',
        AddToCart: 'Agregar al carrito',
        AddToCartSingleProduct: 'Producto individual al carrito',
        AddToWishlist: 'Agregar a favoritos',
        InitiateCheckout: 'Iniciar compra',
        DownloadFile: 'Descarga de archivo',
        DownloadMusic: 'Descarga de música',
        CopyCoupon: 'Copiar cupón',
        CopyDiscount: 'Copiar descuento',
        QR_ScanQrCode: 'Escaneo de código QR',
        VisitPage: 'Visita de página',
      },
    },
    sensitive: {
      title: 'Material sensible',
      subtitle: 'Mostrar una advertencia de contenido sensible antes de mostrar su sitio web',
    },
    socialIntegration: {
      title: 'Integración social',
      subtitle: 'Administre sus integraciones de Instagram y TikTok',
      connectInstagram: 'Conectar Instagram',
    },
    emailIntegration: {
      title: 'Integraciones de audiencia',
      subtitle: 'Pase las direcciones de correo electrónico de sus visitantes a MailChimp, Reply',
      emailCaption: 'Agregue una integración para pasar las direcciones de correo electrónico de sus seguidores a MailChimp',
      mailChimp: 'Integraciones de MailChimp',
      selzy: 'Integraciones de Selzy',
      selzyCaption: 'Agregue una API Key para pasar las direcciones de correo electrónico de sus seguidores a Selzy',
      sendPulse: 'Integraciones de SendPulse',
      sendPulseCaption: 'Agregue una API Key para pasar las direcciones de correo electrónico de sus seguidores a SendPulse',
      reply: 'Integraciones de Reply',
      replyCaption: 'Agregue una API Key para pasar las direcciones de correo electrónico de sus seguidores a',
      integrations: 'integraciones',
    },
    calendarIntegration: {
      title: 'Calendar integrations',
      subtitle: 'Connect your calendar services',
      calendly: 'Calendly',
      calendlyDescription: 'Connect Calendly to sync your event types and availability',
      googleCalendar: 'Google Calendar',
      googleCalendarDescription: 'Connect Google Calendar to sync events and create Google Meet links',
      zoom: 'Zoom',
      zoomDescription: 'Connect Zoom to create meeting links automatically',
      googleMeet: 'Google Meet',
      googleMeetDescription: 'Create Google Meet links automatically (requires Google Calendar)',
    },
    storage: {
      title: 'Almacenamiento',
      subtitle: 'Guardar pedidos de visitantes en Google Spreadsheet',
      storageCaption: 'Agregue una integración para guardar todos los pedidos de clientes en Google Spreadsheet',
      emailSignup: 'Registro por correo electrónico',
      emailSignupsCaption: 'Elija la tabla para guardar registros de correo electrónico',
      formSignups: 'Registro de formulario',
      forSignupsCaption: 'Elija la tabla para guardar registros de formulario',
      shopOrders: 'Pedidos de tienda',
      shopOrderCaption: 'Elija la tabla para guardar pedidos de tienda',
      disconnect: 'Desconectar hoja de cálculo',
      storageUsage: 'Uso de almacenamiento',
      of: 'de',
      uses: 'Esta aplicación usa',
      space: 'de su espacio libre en disco',
      view: 'ver detalles',
      noItems: 'No hay elementos',
      files: 'Archivos',
      images: 'Imágenes',
      videos: 'Videos',
      audio: 'Audio',
      settings: 'configuración',
    },
  },
  productStore: {
    title: 'Mostrar pestaña de tienda en su enlace en bio',
    subtitle: 'Su tienda está actualmente oculta.',
  },
  sections: {
    splashScreen: {
      title: 'Pantalla de bienvenida',
      subtitle: 'Se muestra mientras la página se está cargando',
    },
    promo: {
      title: 'Barra promocional',
      subtitle: 'Destacado que le permite mostrar promociones',
      masterPromoMessage:
        'La barra promocional maestra está actualmente habilitada. Si desea crear una barra promocional personalizada para esta página, primero deberá desactivar la barra promocional maestra.',
      titlePlaceholder: '¡Bienvenido a mi sitio web!',
      switcherIsMasterPromobar: 'Mostrar en todas las páginas',
    },
    contact: {
      title: 'Contactos',
      subtitle: 'Proporcione la forma de comunicarse con usted',
      caption: 'Agregue botones de mensajería para una conexión rápida entre usted y sus clientes con un solo clic',
      tooltip: 'Contactos permite a los usuarios comunicarse directamente con usted. Agregue su teléfono, correo electrónico, mensajero o ubicación',
      addNewContact: 'Agregar nuevo contacto',
      addContact: 'Agregar contacto',
      chooseContact: 'Elegir contacto',
      enterLink: 'Ingrese su enlace de contacto',
      showDetails: 'Mostrar detalles',
      enterAnyContact: 'Ingrese cualquier contacto',
      enterAnyContactCaption: '(WhatsApp, Telegram, Viber, Messenger)',
    },
    membership: {
      title: 'Membresía',
      subtitle: 'Cree una suscripción gratuita o de pago a su contenido',
      addNewTier: 'Agregar nuevo nivel',
      editTier: 'Editar nivel',
      name: 'Nombre',
      nameCaption: 'Ingrese el nombre de su nivel',
      price: 'Precio por mes',
      priceCaption: 'Ingrese el precio de su nivel',
      month: 'mes',
      image: 'Imagen',
      imageCaption: 'Suba una imagen para su nivel',
    },
    pricing: {
      title: 'Precios',
      subtitle: 'Cree un menú con precios',
      add: 'Agregar nuevo elemento',
      edit: 'Editar elemento',
      name: 'Nombre',
      nameCaption: 'Ingrese el nombre de su elemento',
      duration: 'Atributo',
      durationCaption: 'Ingrese el tiempo, cantidad o duración de su elemento',
      category: 'Categoría',
      categoryCaption: 'Ingrese la categoría de su elemento',
      price: 'Precio',
      priceCaption: 'Ingrese el precio de su elemento',
      month: 'mes',
      image: 'Imagen',
      imageCaption: 'Suba una imagen para su elemento',
    },
    subscribe: {
      dataCollectTitle: 'Recopilación de datos',
      title: 'Suscribirse',
      subtitle: 'Recopile correos electrónicos o números de teléfono de sus visitantes',
      instructionsMessage: '¡Agregue un campo de registro por correo electrónico a su página para que sus visitantes puedan registrarse fácilmente!',
      instructionsLink: 'Pase correos electrónicos a MailChimp para ejecutar campañas de marketing.',
      sectionHeaderCaption: 'Suscríbase a nuestro boletín',
      collecting: 'Recopilando',
      collectingCaption: 'Elija su tipo de entrada',
      addDataToCollect: 'Agregar datos para recopilar',
      email: 'Correo electrónico',
      enterEmail: 'Ingrese correo electrónico',
      thanksForEmail: 'Gracias por su correo electrónico',
      phone: 'Teléfono',
      telegram: 'Telegram',
      facebook: 'Facebook',
      instagram: 'Instagram',
      twitter: 'X (Twitter)',
      youtube: 'Youtube',
      whatsapp: 'Whatsapp',
      viber: 'Viber',
      messenger: 'Messenger',
      modalTitle: 'Agregar enlaces actualizados',
      placeholder: 'Placeholder',
      placeholderCaption: 'Ingrese el texto del placeholder',
      button: 'Botón',
      buttonCaption: 'Texto que motivará al visitante a ingresar su correo electrónico (10% de descuento, suscribirse ahora, descargar archivo, etc.)',
      submitButton: 'Botón de envío',
      enterButton: 'Botón de ingreso',
      thanksMessage: 'Mensaje de agradecimiento',
      thanksMessageCaption: 'Mensaje de agradecimiento para sus suscriptores',
      resultAction: 'Acción (después de enviar)',
      resultActionCaption: 'Acción después de completar el formulario',
      sendAnEmail: 'Enviar un correo electrónico',
      downloadFile: 'Descargar archivo',
      redirect: 'Redirigir',
      messageBody: 'Cuerpo del mensaje',
      messageBodyCaption: 'Estos datos se enviarán al correo electrónico del usuario como regalo por su correo electrónico (cupón, enlace de descarga, etc.)',
      integration: 'Integración',
      integrationCaption: 'Pase las direcciones de correo electrónico de sus visitantes a MailChimp, Reply',
      storage: 'Almacenamiento',
      storageCaption: 'Guardar pedidos de visitantes en Google Spreadsheet',
      maxSize: 'Puede agregar un máximo de 3 canales',
    },
    text: {
      title: 'Texto',
      subtitle: 'Escriba cualquier cosa sobre usted/empresa',
      trimBio: 'Botón Ver más',
    },
    header: {
      title: 'Encabezado',
      subtitle: 'Imagen o video destacado ampliado en su página',
      verifiedBadge: 'Insignia verificada',
      showProfilePic: 'Mostrar foto de perfil',
      profilePicRatio: 'Proporción',
      profilePicRatioSquare: 'Cuadrado',
      profilePicRatioLandscape: 'Horizontal',
      profilePicRatioPortrait: 'Vertical',
      namePlaceholder: 'Su nombre',
      shortBioPlaceholder: 'Mi información breve',
      externalLinkPlaceholder: 'URL',
      locationPlaceholder: 'Ciudad',
      addSocial: '+ Agregar red social',
      addCover: '+ Agregar portada',
      addButton: '+ Agregar botón',
      addText: '+ Agregar texto',
      addLabel: '+ Agregar etiqueta',
      subtitleName: 'Personalice la apariencia de su nombre',
      subtitleShortBio: 'Personalice la apariencia de su biografía corta',
      shortBioSize: 'Tamaño de la biografía corta',
      subtitleShortBioSize: 'Puede cambiar el tamaño de la biografía corta',
      subtitleLocation: 'Configure la ciudad/país para guiar a los visitantes a un lugar específico',
      headerCoverWarningMessage: 'Su navegador no soporta la etiqueta de video.',
      headerCoverTitle: 'Establecer portada sobre el encabezado',
      coverHeight: 'Altura de portada',
      subtitleCoverHeight: 'Puede cambiar la altura de la portada',
      coverDarkness: 'Oscuridad de portada',
      subtitleCoverDarkness: 'Arrastre el control deslizante para oscurecer la imagen de portada',
      nameSize: 'Tamaño del nombre',
      subtitleNameSize: 'Puede cambiar el tamaño del nombre',
      positionText: 'Posición del nombre',
      subtitlePositionName: 'Arrastre el control deslizante para establecer la posición del nombre',
      positionContent: 'Posición del contenido',
      subtitlePositionContent: 'Establecer posición para biografía, enlace, ubicación',
      coverText: 'Texto en portada',
      subtitleCoverText: 'Agregue texto a su portada',
      position: 'Posición',
      subtitlePosition: 'Arrastre el control deslizante para establecer la posición del botón',
      buttonCover: 'Botón en portada',
      subtitleButtonCover: 'Agregue un botón a su portada eligiendo una acción',
      subtitleFollow: 'El botón de seguir permite a los usuarios seguir sus noticias',
      buttonOpacity: 'Arrastre el control deslizante para cambiar la opacidad del botón',
      subtitleCart: 'Ícono de carrito para ofrecer una experiencia de compra',
      subtitleDirect: 'Botón rápido para dirigir al visitante a mensajeros',
      subtitleCTAButton: 'Botón (llamada a la acción) que motiva al usuario a hacer clic',
      subtitleSocialLinks: 'Dele a sus redes sociales una apariencia visual',
      chooseSocialLink: 'Elegir enlace social',
      alignSocialLink: 'Alineación de enlaces sociales',
      enterYourSocialLink: 'Ingrese su enlace social',
      blockShadow: 'Sombra del bloque',
      activeButtonPosition: 'Posición del botón activo',
      gradientColor: 'Color degradado',
      bottomGradient: 'Degradado inferior',
      autoGradient: 'Automático',
      customGradient: 'Personalizado',
      uploadLogo: 'Subir logo',
      customBackground: 'Fondo personalizado',
      headingLabel: 'Etiqueta del encabezado',
      customizeLabel: 'Personalice la apariencia de la etiqueta del encabezado',
      labelText: 'Texto de la etiqueta',
      enterLabelText: 'Ingrese el texto para la etiqueta del encabezado',
    },
  },
  billingHistory: {
    title: 'Historial de facturación',
    invoices: 'Facturas',
    messageText: 'Aún no tiene historial de pagos.',
  },
  migrate: {
    title: '¿Tiene LinkTree o Taplink?',
    text: '¡Pegue el enlace y migre a UniLink con un solo clic!',
    button: 'Migrar',
  },
  pages: {
    title: 'Páginas',
    addPage: 'Agregar página',
    addNewPage: 'Agregar nueva página',
    deleteTitle: '¿Está seguro de que desea eliminar esta página?',
    managePage: 'Administrar pestañas',
    empty: 'Esta página aún no tiene ningún bloque.',
    dragAndDrop: 'Arrastre y suelte sus otras pestañas para reordenarlas',
    pageNavigation: 'Configuración de navegación de página',
    goToDesign: 'Ir a configuración de diseño',
    viewArchive: 'Ver archivo',
    archivedBlocks: 'Bloques archivados',
    noArchivedBlocks: 'Mantenga su página limpia y organizada archivando los bloques que no está usando actualmente.',
    archiveAllUnpublished: 'Archivar todos los bloques no publicados',
    restore: 'Restaurar',
    permanentDelete: 'Eliminar permanentemente',
  },
  analytics: {
    lifeTimeAnalytics: 'Analíticas de por vida',
    impressions: 'Impresiones',
    impressionsText: 'Rendimiento de las estadísticas de impresiones para el período elegido',
    clicks: 'Clics',
    clicksText: 'Rendimiento de eventos de "clic" para el período elegido',
    signUps: 'Registros',
    signUpsText: 'Rendimiento de eventos de "cierre" para el período elegido',
    visitor: 'Fuentes de visitantes',
    country: 'País',
    countries: 'Países',
    linkClicks: 'Clics en enlaces',
    content: 'Contenido',
    views: 'Vistas',
  },
  aiInsights: {
    title: 'Insights con IA',
    generate: 'Analizar mi perfil',
    description: 'Obtén recomendaciones con IA para mejorar el rendimiento de tu perfil.',
    analyzing: 'Analizando tu perfil...',
    refresh: 'Actualizar',
    action: 'Acción',
  },
  post: {
    subscriptionTypePlaceholder: "Disponible para suscripción '{type}' y superior",
    postButtonText: 'Publicar',
    newPostPlaceholder: 'Qué tiene en mente',
    free: 'Gratis',
    pro: 'Pro',
    premium: 'Premium',
    noPost: 'Aún no tiene publicaciones',
    editPost: 'Editar publicación',
  },
  preview: {
    buy: 'Comprar',
    connect: 'Conectar',
  },
  activeButton: {
    initialText: 'Sitio web',
    inputPlaceholder: 'Buscar acciones...',
    existing: 'Existente',
    redirect: 'Redirigir',
    scroll: 'Desplazar',
    title: 'Botón activo',
    modalTitle: 'Acción del botón activo',
    subtitle: 'Botón que motiva al usuario a realizar una acción',
    next: 'Siguiente',
    save: 'Guardar',
    opensALinkFromLinksBlock: 'Abre un enlace del bloque de Enlaces',
    url: 'URL',
    opensAWebsite: 'Abre un sitio web',
    openInApp: 'Abrir en la app',
    addAction: 'Agregar acción',
    actionTitle: 'Acción',
    actionCaption: 'Editar tipo de acción',
    chooseOption: 'Elija una opción',
    tellPeople: 'Indique a las personas cómo interactuar con el botón de acción',
    urlRedirect: 'Redirección URL',
    customUrl: 'URL personalizada',
    customUrlText: 'Abre un sitio web',
    links: 'Enlaces',
    linksText: 'Abre un enlace del bloque de enlaces',
    downloadDocument: 'Descargar documento',
    sendEmail: 'Enviar correo',
    opensEmailClient: 'Abre el cliente de correo',
    phoneCall: 'Llamada telefónica',
    initiatesPhoneCall: 'Inicia una llamada telefónica',
    navigation: 'Navegación',
    openPage: 'Abrir página',
    opensInternalPage: 'Abre una página interna',
    openPageText: 'Abre una página interna',
    openProduct: 'Abrir producto',
    openProductText: 'Abre la página del producto desde la tienda',
    openBlog: 'Abrir blog',
    opensBlogPageFromStore: 'Abre la página del blog desde la Tienda',
    openBlock: 'Abrir bloque',
    opensContentBlock: 'Abre el bloque de contenido',
    openItem: 'Abrir elemento',
    opensItemPageFromStore: 'Abre la página del elemento desde la Tienda',
    showNewModal: 'Mostrar nuevo modal',
    displayContentInModalWindow: 'Mostrar contenido en ventana modal',
    showProduct: 'Mostrar producto',
    displayProductInModalWindow: 'Mostrar producto en ventana modal',
    showBlog: 'Mostrar blog',
    scrollToBlock: 'Desplazar al bloque',
    scrollToBlockText: 'Desplaza hasta el bloque de página especificado',
    scrollToItem: 'Desplazar al elemento',
    action: 'Acción',
    showBlock: 'Mostrar bloque',
    showBlockText: 'Muestra el bloque en una ventana modal en la página',
    showItem: 'Mostrar elemento',
    showItemText: 'Muestra el bloque del elemento en una ventana modal en la página',
    linksCaption: 'Enlaces',
    linksTooltip: 'Elija un enlace del bloque de enlaces',
    pagesCaption: 'Páginas',
    pagesTooltip: 'Elija una página de las páginas',
    productsCaption: 'Productos',
    productsTooltip: 'Elija un producto de la lista',
    blocksCaption: 'Bloques',
    blocksTooltip: 'Elija un bloque de la lista',
    itemsCaption: 'Elementos',
    itemsTooltip: 'Elija un elemento de la lista',
    showProductText: 'Muestra el producto en una ventana modal en la página',
    more: 'Mostrar más',
    less: 'Mostrar menos',
    showNewModalTitle: 'Datos del nuevo modal',
    uploadDocumentTitle: 'Haz clic para subir o arrastra y suelta',
    uploadProgressTitle: 'Subiendo...',
    haveNoModal: 'No tienes modal',
    haveModal: 'Has seleccionado modal',
    openNewModalHandler: 'Crear nuevo modal',
    linkGroupSubTitle: 'Selecciona un bloque',
    linkItemSubTitle: 'Selecciona un enlace',
    urlItemSubTitle: 'URL del sitio web',
    openInAppItemSubTitle: 'URL de la app',
    sendEmailItemSubTitle: 'Dirección de correo',
    phoneCallItemSubTitle: 'Número de teléfono',
    openPageGroupSubTitle: 'Seleccionar página',
    openPageItemSubTitle: 'Seleccionar página',
    openProductGroupSubTitle: 'Seleccionar tipo de producto',
    openProductItemSubTitle: 'Seleccionar producto',
    openBlogGroupSubTitle: 'Seleccionar canal del blog',
    openBlogItemSubTitle: 'Seleccionar artículo del blog',
    openBlockGroupSubTitle: 'Seleccionar página',
    openBlockItemSubTitle: 'Seleccionar bloque',
    openItemGroupSubTitle: 'Seleccionar bloque',
    openItemItemSubTitle: 'Seleccionar elemento',
    showProductGroupSubTitle: 'Seleccionar tipo de producto',
    showProductItemSubTitle: 'Seleccionar producto',
    showBlogGroupSubTitle: 'Seleccionar canal del blog',
    showBlogItemSubTitle: 'Seleccionar artículo del blog',
    showBlockGroupSubTitle: 'Seleccionar página',
    showBlockItemSubTitle: 'Seleccionar bloque',
    showItemGroupSubTitle: 'Seleccionar bloque',
    showItemItemSubTitle: 'Seleccionar elemento',
    scrollToBlockGroupSubTitle: 'Seleccionar página',
    scrollToBlockItemSubTitle: 'Seleccionar bloque',
    scrollToItemGroupSubTitle: 'Seleccionar bloque',
    scrollToItemItemSubTitle: 'Seleccionar elemento',
    linkGroupPlaceholder: 'Elige un bloque...',
    linkItemPlaceholder: 'Elige un enlace...',
    openPageItemPlaceholder: 'Elige una página...',
    openProductGroupPlaceholder: 'Elige un tipo de producto...',
    openProductItemPlaceholder: 'Elige un producto...',
    showProductGroupPlaceholder: 'Elige un grupo de productos...',
    showProductItemPlaceholder: 'Elige un producto...',
    openBlogGroupPlaceholder: 'Elige un canal de blog...',
    openBlogItemPlaceholder: 'Elige un artículo de blog...',
    openBlockGroupPlaceholder: 'Elige una página...',
    openBlockItemPlaceholder: 'Elige un bloque...',
    openItemGroupPlaceholder: 'Elige una página y un bloque...',
    openItemItemPlaceholder: 'Elige un elemento...',
    showBlogGroupPlaceholder: 'Elige un grupo de blog...',
    showBlogItemPlaceholder: 'Elige una entrada de blog...',
    showBlockGroupPlaceholder: 'Elige una página...',
    showBlockItemPlaceholder: 'Elige un bloque...',
    showItemGroupPlaceholder: 'Elige una página y bloque...',
    showItemItemPlaceholder: 'Elige un elemento...',
    scrollToBlockGroupPlaceholder: 'Elige una página...',
    scrollToBlockItemPlaceholder: 'Elige un bloque...',
    scrollToItemGroupPlaceholder: 'Elige una página y bloque...',
    scrollToItemItemPlaceholder: 'Elige un elemento...',
    linkReadable: 'Enlace',
    urlReadable: 'URL',
    openInAppReadable: 'Abrir en la app',
    downloadDocumentReadable: 'Descargar documento',
    sendEmailReadable: 'Enviar correo',
    phoneCallReadable: 'Llamada telefónica',
    openPageReadable: 'Abrir página',
    openProductReadable: 'Abrir producto',
    showNewModalReadable: 'Mostrar ventana nueva',
    showProductReadable: 'Mostrar producto',
    openBlogReadable: 'Abrir blog',
    openBlockReadable: 'Abrir bloque',
    openItemReadable: 'Abrir elemento',
    showBlogReadable: 'Mostrar blog',
    showBlockReadable: 'Mostrar bloque',
    showItemReadable: 'Mostrar elemento',
    scrollToBlockReadable: 'Desplazar al bloque',
    scrollToItemReadable: 'Desplazar al elemento',
  },
  design: {
    tabs: 'Pestañas',
    imageView: 'Vista de imagen',
    preview: 'Vista previa',
    buttonOpacity: 'Opacidad del botón',
    buttonBorder: 'Borde del botón',
    buttonShadow: 'Sombra del botón',
    itemView: 'Vista del elemento',
    itemViewTooltip: 'Elija la vista del elemento',
    itemLayout: 'Diseño del elemento',
    itemLayoutTooltip: 'Elija el diseño del elemento',
    top: 'Arriba',
    center: 'Centro',
    bottom: 'Abajo',
    bottomLeft: 'Abajo izquierda',
    bottomHorizontal: 'Abajo horizontal',
    under: 'Debajo',
    title: 'Título',
    titleButton: 'Título y botón',
    displayOptions: 'Opciones de visualización',
    displayOptionsTooltip: 'Elija opciones de visualización',
    landscape: 'Horizontal',
    square: 'Cuadrado',
    portrait: 'Vertical',
    desktopMode: 'Modo escritorio',
    mobile: 'Móvil',
    desktop: 'Escritorio',
    responsive: 'Responsivo',
    custom: 'Personalizado',
    templates: 'Plantillas',
    chooseTemplates: 'Elija sus plantillas',
    viewAll: 'Ver todo',
    previousTheme: 'Tenga en cuenta que el tema anterior se eliminará permanentemente.',
    useThisTemplate: 'Usar esta plantilla',
    notSupportedVideo: 'Su navegador no soporta la etiqueta de video.',
    photosBy: 'Fotos de',
    animationBy: 'Animación de',
    searchTheSame: 'Busque el mismo término de nuevo para obtener diferentes resultados.',
    addImage: 'Agregar una imagen',
    addVideo: 'Agregar un video',
    orSelectFrom: 'o seleccionar de',
    noImagesYet: 'Aún no hay imágenes',
    noVideosYet: 'Aún no hay videos',
    videoBy: 'Video de',
    hamburgerMenu: 'Menú hamburguesa',
    tabsOnTop: 'Pestañas arriba',
    tabsOnBottom: 'Pestañas abajo',
    borderType: 'Tipo de borde',
    subTitle: 'Elija forma, tipo de borde, sombra, etc.',
    icon: 'Ícono',
    iconTooltip: 'Elija el ícono adecuado para su botón',
    background: 'Fondo',
    color: 'Color',
    backgroundOpacity: 'Opacidad del fondo',
    backgroundOpacityTooltip: 'Arrastre el control deslizante para establecer la opacidad del fondo',
    gradient: 'Degradado',
    color1: 'Color 1',
    color2: 'Color 2',
    direction: 'Dirección',
    directionTooltip: 'Arrastre el control deslizante para establecer la dirección del degradado',
    offset: 'Desplazamiento',
    offsetTooltip: 'Arrastre el control deslizante para establecer el desplazamiento del degradado',
    minHeight: 'Altura mínima',
    minHeightTooltip: 'Arrastre el control deslizante para cambiar la altura mínima del botón',
    align: 'Alinear',
    alignTooltip: 'Cambiar posición del botón',
    insert: 'Insertar URL',
    upload: 'Subir video',
    search: 'Buscar video',
    layout: 'Diseño',
    layoutTooltip: 'Elija el diseño que desee',
    view: 'Vista',
    viewTooltip: 'Elija la vista que desee',
    media: 'Medios',
    mediaTooltip: 'Elija los medios que desee',
    none: 'Ninguno',
    small: 'Pequeño',
    medium: 'Mediano',
    large: 'Grande',
    round: 'Redondo',
    feed: 'Feed',
    slider: 'Slider',
    text: 'Texto',
    colorTooltip: 'Elegir colores',
    button: 'Botón',
    buttonTooltip: 'Elegir colores del botón',
    chooseEmoji: 'Elegir emoji',
    changeEmoji: 'Cambiar su emoji',
    quantum: 'Quantum',
    emoji: 'Emoji',
    warp: 'Warp',
  },
  components: {
    quickAdd: {
      addLink: 'Agregar enlace',
      addVideo: 'Agregar video',
      addProduct: 'Agregar producto',
      addPost: 'Agregar publicación',
      addArticle: 'Agregar artículo',
      addPhoto: 'Agregar foto',
      addMusic: 'Agregar música',
      addFiles: 'Agregar archivos',
      addStory: 'Agregar historia',
    },
    emoji: {
      search: 'Buscar',
      clear: 'Limpiar',
      notfound: 'No se encontraron emojis',
      skintext: 'Elija su tono de piel predeterminado',
      categories: {
        search: 'Resultados de búsqueda',
        recent: 'Usados frecuentemente',
        smileys: 'Caritas y emociones',
        people: 'Personas y cuerpo',
        nature: 'Animales y naturaleza',
        foods: 'Comida y bebida',
        activity: 'Actividad',
        places: 'Viajes y lugares',
        objects: 'Objetos',
        symbols: 'Símbolos',
        flags: 'Banderas',
        custom: 'Personalizado',
      },
      categorieslabel: 'Categorías de emojis',
      skintones: {
        1: 'Tono de piel predeterminado',
        2: 'Tono de piel claro',
        3: 'Tono de piel medio claro',
        4: 'Tono de piel medio',
        5: 'Tono de piel medio oscuro',
        6: 'Tono de piel oscuro',
      },
    },
    blogPreviewModal: {
      title: 'Vista previa del blog',
      notify: 'Notificar a suscriptores',
    },
    standAloneModal: {
      title: 'Vista previa del enlace',
      save: 'Guardar',
      chooseLayout: 'Elija un diseño para su enlace',
      linkSettings: 'Configuración del enlace',
      linkSettingsSubtitle: 'Redirección, apariencia',
      whenVisitorsClicks: 'Cuando un visitante hace clic en este enlace:',
      redirect: 'Redirigir',
      redirectText: 'Enviar visitantes directamente a la URL',
      highlight: 'Destacar',
      highlightText: 'Enviar visitantes a su UniLink y destacar',
      standalone: 'Independiente',
      standaloneText: 'Haga que su enlace de YouTube se destaque y que el contenido se reproduzca directamente en su',
      cover: 'Portada',
      imageTab: 'Imagen',
      videoTab: 'Video',
      uploadImage: 'Subir imagen',
      whenVisitors: 'Cuando un visitante selecciona el enlace compartido:',
      compact: 'Vista compacta',
      fullView: 'Vista completa',
      videoSound: 'Reproducir video con sonido',
    },
    instagramModal: {
      title: 'Enviar mensajes directos automáticos de Instagram',
      subtitle: 'Envíe este enlace por mensaje directo cuando alguien comente en su publicación o Reel de IG',
      promo: 'Elija desde qué cuenta de IG le gustaría enviar',
      connect: 'Conectar cuenta de Instagram',
      added: 'Cuenta de Instagram agregada',
      addNew: 'Agregar nueva automatización',
      igContent: 'Contenido de IG',
      trigger: 'Disparador',
      dmContent: 'DM',
      linkDestination: 'Destino del enlace',
      buttonTitle: 'Título del botón',
      buttonTitleTooltip: 'Ingrese el título del botón',
      directMessage: 'Mensaje directo',
      directMessageTooltip: 'Ingrese el mensaje directo',
      selectPosts: 'Seleccione la publicación o Reel que activará su DM automático.',
      onePost: 'Una publicación o Reel específico',
      allPosts: 'Todas las publicaciones o Reels',
      triggerText: 'Cuando los comentarios incluyan esto, su DM se enviará.',
      addMessage: 'Agregue un mensaje para enviar automáticamente con su enlace.',
      clickLink: 'Cuando alguien haga clic en el enlace de su DM:',
      anyComment: 'Cualquier comentario',
      specificKeywords: 'Comentarios con palabras clave específicas',
      sendLink: 'Enviarlos a su UniLink y destacar ',
      skipLink: 'Omitir UniLink y enviarlos directamente',
      keywordsTitle: 'Comentarios con palabras clave específicas',
      keywordsText: 'Sus DMs se enviarán cuando los comentarios incluyan o excluyan\npalabras clave específicas (no distingue mayúsculas):',
      keywordsPlaceholder: 'Escriba una palabra clave',
      keywordsExclude: 'Excluir palabras clave',
      keywordsExcludeText: 'Debe excluir cualquiera de estas',
      replyComment: 'Responder comentario',
      replyCommentTooltip: 'Ingrese el comentario de respuesta',
    },
    blockEditProduct: {
      productPreview: 'Vista previa del producto',
      productDetails: 'Detalles del producto',
      settings: 'Configuración',
      design: 'Diseño',
    },
    editMenuItems: {
      overview: 'Resumen',
      analytics: 'Analíticas',
    },
    botToken: {
      bot: 'Bot',
      botTooltip: 'Ingrese el token de su bot',
      connect: 'Conectar',
      token: 'Token',
    },
    rewards: {
      title: 'Título',
      titleTooltip: 'Ingrese el título de la respuesta',
      text: 'Texto',
      textTooltip: 'Ingrese el texto de la respuesta',
      link: 'Enlace',
      linkTooltip: 'Ingrese el enlace de la respuesta',
      code: 'Código',
      codeTooltip: 'Ingrese el código de la respuesta',
      files: 'Archivos',
      filesTooltip: 'Ingrese los archivos de la respuesta',
      removeReward: '¿Está seguro de que desea eliminar esta respuesta?',
    },
    addRewardModal: {
      addReward: 'Agregar respuesta',
      textTitle: 'Texto',
      textText: 'Dé acceso a instrucciones o cualquier texto con el editor enriquecido',
      fileTitle: 'Archivos',
      fileText: 'Dé acceso a archivos y recopile datos de contacto',
      linkTitle: 'Enlace',
      linkText: 'Dé acceso a contenido exclusivo y recopile datos de contacto',
      codeTitle: 'Código',
      codeText: 'Dé acceso a promociones exclusivas y recopile datos de contacto',
    },
    blockEmpty: {
      isNotAdded: 'no se ha agregado',
      itSeems: 'Parece que sus',
      itemsNot: 'elementos aún no se han agregado. Agregue sus videos ahora',
      add: 'Agregar',
    },
    blockList: {
      add: 'Agregar',
      item: 'elemento',
    },
    submitAction: {
      action: 'Acción (después de enviar)',
      actionTooltip: 'Elija una acción después de enviar',
      upload: 'Subir archivos adjuntos',
      none: 'Ninguno',
      page: 'Mostrar página de confirmación',
      email: 'Enviar correo electrónico de confirmación',
      redirect: 'Redirigir a URL',
    },
    blockEditItem: {
      content: 'Contenido',
      preview: 'Vista previa',
      settings: 'Configuración',
    },
    domainButton: {
      customizeDomain: 'Personalice su dominio.',
      upgradeToLink: 'Actualice a enlace en bio Pro y use un dominio personalizado.',
    },
    coverText: {
      text: 'Texto',
      textTooltip: 'Ingrese texto en su portada',
      description: 'Descripción',
      descriptionTooltip: 'Ingrese la descripción en su portada',
      textColor: 'Color del texto',
    },
    itemModal: {
      edit: 'Editar',
      addNew: 'Agregar nuevo',
      item: 'elemento',
      update: 'Actualizar',
      add: 'Agregar',
    },
    viewDesign: {
      compact: 'Compacto',
      card: 'Tarjeta',
      button: 'Botón',
      list: 'Lista',
      hero: 'Hero',
      featured: 'Destacado',
    },
    moveItemModal: {
      title: 'Mover elemento a otra página',
      cancel: 'Cancelar',
      move: 'Mover',
      page: 'Página',
      pageTooltip: 'Elija una página para mover el elemento',
      blocks: 'Bloques',
      blocksTooltip: 'Elija un bloque para mover el elemento',
      emptyBlocks: 'No hay bloques requeridos en esta página.',
    },
    limitModal: {
      title: 'Límite alcanzado',
      text1: 'Ha alcanzado el límite de su sitio.',
      text2: 'Contáctenos para mejorar su plan.',
      close: 'Cerrar',
    },
    cropPicture: {
      title: 'Recorte su imagen',
      cancel: 'Cancelar',
      save: 'Guardar',
    },
    uploadFile: {
      uploadProductImage: 'Subir imagen del producto',
      coverImage: 'Imagen de portada',
      uploadImages: 'Solo puede subir imágenes aquí',
    },
    userMediaLibrary: {
      addImage: 'Agregar una imagen',
      uploadImage: 'Subir imagen',
      orSelectFrom: 'o subir',
      orSelectLink: 'o pegar enlace',
      myMedia: 'Mis medios',
      stockImages: 'Imágenes de stock',
      gifs: 'GIFs',
      icons: 'Íconos',
      noImagesYet: 'Aún no hay imágenes',
      loadMore: 'Cargar más',
    },
    itemMenu: {
      active: 'Activo',
      willBeAvailable: 'El elemento estará disponible en:',
      save: 'Guardar',
      copied: 'Copiado',
      copyLink: 'Copiar enlace',
      delete: 'Eliminar',
    },
    itemDesign: {
      linkColor: 'Color del enlace',
      gradient: 'Degradado',
      background: 'Fondo',
      backgroundOpacity: 'Opacidad del fondo',
      backgroundOpacityTooltip: 'Arrastre el control deslizante para establecer la opacidad del fondo',
      backgroundDarkness: 'Oscuridad del fondo',
      backgroundDarknessTooltip: 'Arrastre el control deslizante para establecer la oscuridad del fondo',
      text: 'Texto',
      color1: 'Color 1',
      color2: 'Color 2',
      direction: 'Dirección',
      directionTooltip: 'Arrastre el control deslizante para establecer la dirección del degradado',
      offset: 'Desplazamiento',
      offsetTooltip: 'Arrastre el control deslizante para establecer el desplazamiento del degradado',
      linkHeight: 'Altura del enlace',
      linkHeightTooltip: 'Arrastre el control deslizante para cambiar la altura del botón',
      icon: 'Ícono',
      iconTooltip: 'Elija un ícono para su botón',
      imageShape: 'Forma de la imagen',
      imageShapeTooltip: 'Elija la forma de la imagen para su enlace',
    },
    menu: {
      linkInBio: 'Enlace en bio',
      linkInBioApps: 'Enlace en bio',
      audience: 'Audiencia',
      orders: 'Pedidos',
      marketing: 'Marketing',
      emailMarketing: 'Email Marketing',
      socialPlanner: 'Planificador social',
      shortLinks: 'Acortador de enlaces',
      recentProfiles: 'Perfiles recientes',
      standalonePage: 'Página independiente',
      soloApps: 'App en bio',
      bots: 'Bots',
      smartReply: 'Smart Reply',
      analytics: 'Analíticas',
      settings: 'Configuración',
      shop: 'Ganar',
      publish: 'Publicar',
      studio: 'Estudio',
      blog: 'Blog',
      qrCodes: 'Códigos QR',
      singlePages: 'Apps',
      forms: 'Formularios',
      form: 'Formularios',
      automations: 'Automatizaciones',
      community: 'Comunidad',
      messages: 'Bandeja de entrada',
      agents: 'Agentes',
      apps: 'Apps',
    },
    notificationsBlockSetting: {
      title: 'Notificaciones',
      setUp: 'Configurar',
      notifications: 'notificaciones',
      connect: 'Conectar',
      telegramText: 'Reciba una notificación de Telegram cuando alguien realice',
      change: 'cambio',
      email: 'Correo electrónico',
      emailText: 'Reciba un correo electrónico cuando alguien realice',
      webhook: 'Webhook',
      webhookTooltip: 'Agregar webhook',
      activate: 'Activar',
      webhookText: 'Envíe un evento a un sitio web de terceros cuando alguien realice',
      webhookURL: 'URL del webhook (solicitud POST)',
      error: 'Ingrese un enlace correcto',
      save: 'Guardar',
    },
    navigation: {
      content: 'Contenido',
      pages: 'Páginas',
      posts: 'Publicaciones',
      shop: 'Tienda',
      blog: 'Blog',
      design: 'Diseño',
      analytics: 'Analíticas',
      settings: 'Configuración',
      apps: 'Aplicaciones',
      store: 'Tienda',
    },
    headerSettings: {
      design: 'Diseño',
      analytics: 'Analíticas',
      settings: 'Configuración',
      editTabs: 'Editar pestañas',
    },
    unlockModal: {
      title: 'Desbloquear funciones Pro',
      text: 'Obtenga más de su enlace en bio. Solo $5/mes: desbloquee todo lo que Pro tiene para ofrecer:',
      checkBoxTitle1: 'Más bloques:',
      checkBoxText1: 'Agregue formularios, tiendas, temporizadores y reproductores multimedia',
      checkBoxTitle2: 'Analíticas avanzadas:',
      checkBoxText2: 'Rastree clics, vistas e información de la audiencia',
      checkBoxTitle3: 'Dominio personalizado:',
      checkBoxText3: 'Use su propio dominio para una apariencia profesional',
      checkBoxTitle4: 'Tienda integrada:',
      checkBoxText4: 'Venda productos y administre pedidos con facilidad',
      checkBoxTitle5: 'Herramientas SEO:',
      checkBoxText5: 'Posiciónese mejor con etiquetas meta, UTM y slugs personalizados',
      checkBoxTitle6: 'Integraciones:',
      checkBoxText6: 'Sincronice con Mailchimp, Zapier y otras herramientas',
      checkBoxTitle7: 'Email Marketing:',
      checkBoxText7: 'Recopile prospectos y envíe campañas automatizadas',
      checkBoxTitle8: 'Soporte prioritario:',
      checkBoxText8: 'Obtenga ayuda más rápida siempre que la necesite',
      upgradeToPro: 'Mejorar a Pro',
      viewAllPlans: 'Ver todos los planes',
    },
    profileSwitcher: {
      title: 'Todos los perfiles',
      button: 'Agregar un nuevo perfil',
    },
    account: {
      signOut: 'Cerrar sesión',
      createNew: 'Crear un nuevo enlace en bio',
      tryPro: '¡Pruebe Pro ahora!',
      tryProText: '¡Obtenga personalización avanzada e información más profunda de la audiencia para obtener más visitantes!',
    },
    accountSettings: {
      title: 'Configuración de la cuenta',
    },
    billingHistory: {
      title: 'Historial de facturación',
    },
    pages: {
      home: 'Inicio',
      newPage: 'Nueva página',
      managePages: 'Administrar páginas',
    },
    blockItem: {
      actionRequired: 'acción requerida',
    },
    blockContent: {
      untitled: 'Sin título',
      clickToRename: 'Haga clic para renombrar el subtítulo',
      saving: 'guardando',
      saved: 'guardado',
      deleteTitle: '¿Está seguro de que desea eliminar este bloque?',
      cancel: 'Cancelar',
      yes: 'Sí',
    },
    addButtonModal: {
      title: 'Agregar un botón de acción',
      close: 'Cerrar',
      added: 'Agregado',
      add: 'Agregar',
      messageTitle: 'Mensaje',
      messageText: 'El botón de mensaje permite a los usuarios contactarlo a través de un mensajero',
      subscribeTitle: 'Suscribirse',
      subscribeText: 'El botón de suscripción permite a los usuarios suscribirse a su lista de correo electrónico o mensajería',
      ctaTitle: 'Botón CTA',
      ctaText: 'CTA es un aviso en un sitio web que le dice al usuario que realice una acción específica',
      cartTitle: 'Carrito',
      cartText: 'Muestre un ícono de carrito de compras para indicar que los visitantes pueden realizar compras en su sitio web',
      contactTitle: 'Contacto',
      contactText: 'Permita que los visitantes accedan rápidamente a su información de contacto',
      qrcodeTitle: 'Código QR',
      qrcodeText: 'Muestre un código QR para que los visitantes puedan escanear y compartir su página rápidamente',
      languageTitle: 'Idioma',
      languageText: 'Permite a los visitantes cambiar el idioma de tu página',
    },
    inputMask: {
      copyLink: 'Copiar enlace',
    },
    videoLibrary: {
      addVideo: 'Agregar video',
      myVideos: 'Mis videos',
      stockVideos: 'Videos de stock',
      pasteUrl: 'Pegar URL',
      uploadVideo: 'Subir video',
    },
    createBlockModal: {
      searchTitle: 'Seleccione de nuestra amplia variedad de enlaces e información de contacto a continuación.',
      title: 'Agregar a UniLink',
      contentTitle: 'Contenido',
      contentText: 'Cree y administre su página',
      growTitle: 'Prospectos',
      growText: 'Recopile prospectos y aumente la interacción',
      monetizeTitle: 'Monetizar',
      monetizeText: 'Venda productos, contenido y servicios',
      monetizationTitle: 'Gane y recopile dinero',
      monetizationText: 'Venda productos, servicios y recopile propinas',
      socialTitle: 'Contenido de redes sociales',
      socialText: 'Comparta contenido de redes sociales en su UniLink',
      toolsTitle: 'Herramientas de crecimiento',
      toolsText: 'Crezca, administre y conéctese con su audiencia',
      search: 'Buscar',
      all: 'Todos',
      allCategories: 'Todas las categorías',
      content: 'Contenido',
      monetization: 'Monetización',
      social: 'Social',
      tools: 'Herramientas',
      header: 'Encabezado',
      headerText: 'Agregue una foto de perfil y biografía',
      link: 'Enlaces',
      linkText: 'Seleccione el diseño de enlaces',
      text: 'Texto',
      textText: 'Seleccione el diseño de texto',
      videos: 'Videos',
      videosText: 'Seleccione el tipo de video',
      image: 'Imagen',
      imageText: 'Agregue bloques de imagen',
      music: 'Música',
      musicText: 'Seleccione el tipo de música',
      socialFeeds: 'Feeds sociales',
      socialFeedsText: 'Seleccione el tipo de feed social',
      moreContent: 'Más',
      moreContentText: 'Agregue más bloques de contenido',
      dataCollect: 'Recopilación de datos',
      dataCollectText: 'Seleccione el tipo de recopilación de datos',
      form: 'Formulario',
      formText: 'Seleccione el tipo de formulario',
      conversionTools: 'Herramientas de interacción',
      conversionToolsText: 'Agregue bloques de conversión',
      products: 'Productos',
      productsText: 'Agregue bloques de productos',
      donation: 'Propinas y donaciones',
      tipsAndDonations: 'Propinas y donaciones',
      tipsDonationsText: 'Bloques de propinas y donaciones',
      event: 'Evento',
      eventText: 'Seleccione el tipo de evento',
      quickAdd: 'Todos los bloques',
      quickAddText: 'Agregar cualquier bloque',
    },
    addBlockModal: {
      title: 'Agregar a UniLink',
      dragToAdd: 'Arrastre para agregar',
      contentTitle: 'Compartir contenido básico',
      contentText: 'Comparta contenido directamente en su UniLink',
      monetizationTitle: 'Gane y recopile dinero',
      monetizationText: 'Venda productos, servicios y recopile propinas',
      socialTitle: 'Contenido de redes sociales',
      socialText: 'Comparta contenido de redes sociales en su UniLink',
      toolsTitle: 'Herramientas de crecimiento',
      toolsText: 'Crezca, administre y conéctese con su audiencia',
      search: 'Buscar',
      searchPlaceholder: 'Buscar contenido...',
      all: 'Todos',
      allCategories: 'Todas las categorías',
      content: 'Contenido',
      monetization: 'Monetización',
      social: 'Social',
      tools: 'Herramientas',
    },
    tabNavigation: {
      tabView: 'Vista de pestañas',
      tabViewTooltip: 'Seleccione la vista de pestañas para la navegación',
      colors: 'Colores',
      colorsTooltip: 'Elija colores de publicaciones y botones',
      tabs: 'Pestañas',
      tabsTooltip: 'Elija las pestañas que se muestran en la navegación del sitio web',
      content: 'Contenido',
      posts: 'Publicaciones',
      store: 'Tienda',
      shop: 'Tienda',
      tabsSettings: 'Configuración de navegación por pestañas',
    },
    hideLogo: {
      text: 'Mostrar el logo de UniLink en el pie de página de su página.',
      text2: 'Mostrar el logo de UniLink en el pie de página de su página.',
    },
    palettePreview: {
      custom: 'Color de fondo personalizado',
      hexColor: 'Color hexadecimal',
      hexColorTooltip: 'Ingrese el color hexadecimal de su vista previa',
    },
    backgroundVideo: {
      insert: 'Insertar URL',
      upload: 'Subir video',
      search: 'Buscar video',
    },
    periodDropdown: {
      today: 'Hoy',
      yesterday: 'Ayer',
      last7days: 'Últimos 7 días',
      last30days: 'Últimos 30 días',
      allTime: 'Todo el tiempo',
      custom: 'Personalizado',
    },
    subsections: {
      content: 'Contenido',
      design: 'Diseño',
      settings: 'Configuración',
    },
    wrapperSettings: {
      lock: 'Actualizar al plan PRO',
    },
    shareModal: {
      addSocials: 'Agregar a redes sociales',
      shareTo: 'Compartir en',
      qrCode: 'Código QR',
      customizeUrl: 'Personalizar URL',
      goToMy: 'Ir a mi',
      print: 'Puede imprimir su código QR único en',
      cards: 'tarjetas de presentación y folletos',
      download: 'Descargar',
      copy: 'Copiar',
      previewMobile: 'Vista previa en móvil',
      scanMobilePreview: 'Escanee el código QR en su dispositivo móvil para previsualizar su sitio web',
      types: {
        socials: 'redes sociales',
        shareTo: 'compartir',
        qrCode: 'QR',
        title: 'Comparta su UniLink',
        titleSocials: 'Agregue UniLink a sus redes sociales',
        titleShareTo: 'Compartir en...',
        titleQRCode: 'Código QR',
        titlePreviewMobile: 'Vista previa en móvil',
      },
      socialList: {
        instagramText: 'Agregue su UniLink a su perfil de Instagram. Simplemente copie la URL de su UniLink, vaya a Editar perfil y péguela en el campo de sitio web.',
        facebookText:
          'Agregue su UniLink a su perfil de Facebook. Simplemente copie la URL de su UniLink, vaya a la página Acerca de en su perfil, haga clic en Información de contacto y básica, luego haga clic en + Agregar un sitio web, pegue la URL de su UniLink en el campo de dirección del sitio web y haga clic en Guardar.',
        tikTokText:
          'Agregue su UniLink a su perfil de Facebook. Simplemente copie la URL de su UniLink, vaya a la página Acerca de en su perfil, haga clic en Información de contacto y básica, luego haga clic en + Agregar un sitio web, pegue la URL de su UniLink en el campo de dirección del sitio web y haga clic en Guardar.',
        twitchText:
          'Agregue su UniLink a su canal de Twitch. Simplemente copie la URL de su UniLink, vaya a su canal de Twitch, haga clic en Acerca de, luego haga clic en Editar configuración de acerca de y enlaces, desplácese hasta Enlaces sociales, agregue UniLink en el primer campo de texto y pegue la URL de su UniLink en el segundo campo de texto, luego haga clic en Agregar.',
        youTubeText:
          'Agregue su UniLink a su canal de YouTube. Simplemente copie la URL de su UniLink, vaya a su canal de YouTube, haga clic en Personalizar canal, luego haga clic en Información básica y en Enlaces, agregue un título de enlace y pegue la URL de su UniLink en el campo de URL, luego haga clic en Publicar.',
        linkedInText:
          'Agregue su UniLink a su perfil de LinkedIn. Simplemente copie la URL de su UniLink, vaya a su perfil de LinkedIn, haga clic en el ícono del lápiz, desplácese hasta Información de contacto, pegue la URL de su UniLink en el campo de URL del sitio web, luego haga clic en Aplicar.',
        pinterestText:
          'Agregue su UniLink a su perfil de Pinterest. Simplemente copie la URL de su UniLink, vaya a la configuración de Pinterest, pegue la URL de su UniLink en el campo de URL del sitio web, luego haga clic en Guardar.',
        twitterText:
          'Agregue su UniLink a su perfil de Twitter. Simplemente copie la URL de su UniLink, vaya a su perfil, haga clic en Editar perfil y pegue la URL de su UniLink en el campo de sitio web.',
      },
      share: {
        shareFacebook: 'Compartir en Facebook',
        shareLinkedIn: 'Compartir en LinkedIn',
        shareTwitter: 'Compartir en Twitter',
        shareWhatsApp: 'Compartir vía WhatsApp',
        shareMessenger: 'Compartir vía Messenger',
        shareEmail: 'Compartir vía correo electrónico',
      },
    },
  },
  popupMenu: {
    edit: 'Editar página',
    openInNewTab: 'Abrir en nueva pestaña',
    copyLink: 'Copiar URL',
    delete: 'Eliminar',
    showThumbnail: 'Mostrar miniaturas de páginas en el panel',
    manageTabs: 'Administrar pestañas',
  },
  tabsDashboard: {
    labelAddNewTab: 'Nueva pestaña',
  },
  blocks: {
    header: {
      blockTitle: 'Encabezado',
      blockText: 'Personalice su foto de perfil, agregue una biografía corta y actualice sus íconos sociales',
      blockShortText: 'Personalice su perfil',
      layout: 'Diseño',
      layoutTooltip: 'Cree el diseño de encabezado que desee',
      layoutAlign: 'Alineación del diseño',
      layoutAlignTooltip: 'Alinear texto',
      profilePicture: 'Foto de perfil',
      profilePictureTooltip: 'Cambie su foto de perfil',
      pictureSize: 'Tamaño de la imagen',
      pictureSizeTooltip: 'Puede cambiar el tamaño de la imagen',
      pictureHeight: 'Altura de la imagen',
      pictureHeightCaption: 'Puede cambiar la altura de la imagen',
      preview: 'Vista previa',
      badge: 'Insignia',
      badgeTooltip: 'Agregar una insignia verificada al encabezado',
      visibility: 'Visibilidad',
      visibilityTooltip: 'Mostrar u ocultar la foto de perfil',
      cover: 'Portada',
      coverTooltip: 'Agregar imagen o video a la portada del encabezado',
      addCover: 'Agregar portada',
      image: 'Imagen',
      video: 'Video',
      positionCover: 'Posición del texto y botón',
      positionCoverTooltip: 'Arrastre el control deslizante para cambiar la posición',
      buttons: 'Botones',
      block: 'Bloque',
      videoProcessing: 'Procesamiento de video',
      vibe: 'Vibra',
      vibeTooltip: 'Agregue su vibra',
      stories: 'Historias',
      storiesTooltip: 'Agregue sus historias',
      addStory: 'Agregar historia',
      storiesSubtitle: 'Agregue imagen o video a sus historias',
      subscribeMethod: 'Método de suscripción',
      subscribeMethodTooltip: 'Elija su método de suscripción',
      subscribeLink: 'Enlace de suscripción',
      subscribeLinkTooltip: 'Copie su enlace de suscripción',
      minWidth: 'Ancho mínimo',
      addVCard: 'Agregar VCard',
      vCard: 'VCard',
      vCardTooltip: 'Puede agregar información sobre usted',
      buttonInline: 'Botón en línea del encabezado',
      buttonInsideContact: 'Botón dentro del botón de contacto',
      showSaveContact: 'Mostrar guardar contacto',
      needAddContact: 'Necesita agregar el botón de contacto',
      socialGap: 'Espaciado',
      socialGapCaption: 'Puede cambiar el espaciado',
      socialSize: 'Tamaño',
      socialSizeCaption: 'Puede cambiar el tamaño',
      icons: 'Íconos',
      iconsTooltip: 'Agregar ícono al botón',
    },
    text: {
      blockTitle: 'Texto',
      blockText: 'Bloque de texto general para escribir lo que desee. Puede formatear su texto con el editor WYSIWYG',
      blockShortText: 'Bloque de texto general',
      title: 'Título',
      titleText: 'Personalice el tamaño de su título',
      orderOfElements: 'Orden de elementos',
      orderOfElementsTooltip: 'Arrastre el control deslizante para cambiar el orden de los elementos',
      changeOrder: 'Cambiar orden',
      text: 'Texto',
      content: 'Contenido',
      image: 'Imagen',
      button: 'Botón',
      addButtons: 'Añadir más botones',
      displayedContent: 'Contenido mostrado',
      displayedContentTooltip: 'Mostrar u ocultar contenido',
      buttonLayout: 'Diseño del botón',
      buttonLayoutTooltip: 'Elija la disposición vertical u horizontal del botón',
    },
    timeline: {
      blockTitle: 'Cronología',
      blockText: 'Muestra una cronología vertical con eventos. Cada evento puede tener fecha/hora, título, descripción e imagen opcional',
      blockShortText: 'Mostrar cronología de eventos',
      editItem: 'Editar evento',
      title: 'Título',
      titlePlaceholder: 'Título del evento',
      subtitle: 'Subtítulo',
      subtitlePlaceholder: 'Cargo o afiliación (opcional)',
      description: 'Descripción',
      descriptionPlaceholder: 'Descripción del evento (opcional)',
      startTime: 'Hora de inicio',
      endTime: 'Hora de fin',
      startDate: 'Fecha de inicio',
      endDate: 'Fecha de fin',
      showEndDate: 'Mostrar fecha de fin',
      showEndDateTooltip: 'Desactiva para eventos en curso (p. ej. "trabajando aquí desde 2023")',
      includeTime: 'Incluir hora',
      includeTimeTooltip: 'Si está desactivado, solo se mostrará la fecha sin la hora',
      image: 'Imagen',
      imagePlaceholder: 'Sube un avatar o icono',
      imageUploadFailed: 'No se pudo subir la imagen. Usa Mis archivos o pega un enlace.',
      untitled: 'Sin título',
      listLayout: 'Diseño de lista',
      lineColor: 'Color de la línea',
    },
    trust: {
      blockTitle: 'Confianza',
      blockShortText: 'Comparta sus colaboraciones',
      blockText: 'Coloque todas sus conexiones en un solo lugar.',
      titleText: 'Personalice el tamaño de su título',
      orderOfElements: 'Orden de elementos',
      orderOfElementsTooltip: 'Arrastre el control deslizante para cambiar el orden de los elementos',
      changeOrder: 'Cambiar orden',
      text: 'Texto',
      content: 'Contenido',
      image: 'Imagen',
      button: 'Botón',
      displayedContent: 'Contenido mostrado',
      displayedContentTooltip: 'Mostrar u ocultar contenido',
      enterTrustLink: 'Ingrese la URL del socio',
      enterTrustLinkTooltip: 'Pegue la URL del socio',
      enterPartnerName: 'Ingrese el nombre del socio',
      enterPartnerUrl: 'https://www.suSocio.com/',
      enterDescription: 'Ingrese la descripción (opcional)',
      partnerLogo: 'Logo del socio',
      uploadPartnerLogo: 'Suba el logo de su socio',
    },
    link: {
      blockTitle: 'Enlaces',
      blockText: 'Dirija tráfico a su sitio web, blog, tienda en línea o cualquier otra página web',
      blockShortText: 'Dirija tráfico al sitio web',
      addLink: 'Agregar enlace',
      addNewLink: 'Agregar nuevo enlace',
      viewArchive: 'Ver archivo',
      archivedLinks: 'Enlaces archivados',
      noArchivedLinks: 'Mantenga su administrador de enlaces limpio y enfocado archivando enlaces que no está usando actualmente.',
      archiveAllUnpublished: 'Archivar todos los enlaces no publicados',
      addFormExisting: 'Agregar de enlaces existentes',
      addYourLink: 'Agregue su enlace al grupo',
      add: 'Agregar',
      otherTypes: 'otros tipos de enlaces',
      link: 'Enlace',
      navigate: 'Navegar',
      navigateTo: 'Ir a',
      scrollBlock: 'Scroll to',
      copyText: 'Copy Text',
      navigatePage: 'Página interna',
      navigateProduct: 'Abrir producto',
      navigateBlock: 'Navegar al bloque',
      modal: 'Modal',
      showModal: 'Mostrar modal',
      modalBlock: 'Mostrar bloque',
      modalItem: 'Mostrar elemento',
      modalCustom: 'Personalizado',
      document: 'Documento',
      privat24: 'Privat24',
      phone: 'Llamada telefónica',
      viber: 'Abrir Viber',
      skype: 'Abrir Skype',
      email: 'Enviar correo electrónico',
      discount: 'Descuento',
      smartLink: 'Enlace inteligente',
      mobileApp: 'Deep Link',
      enterURL: 'Ingrese la URL',
      enterPrivat: 'Ingrese su tarjeta de Private Bank',
      enterPhone: 'Ingrese el número de teléfono',
      enterViber: 'Ingrese el número de Viber',
      enterSkype: 'Ingrese Skype',
      enterEmail: 'Ingrese el correo electrónico',
      enterTitle: 'Ingrese el título',
      enterCopyText: 'Ingrese el texto a copiar',
      enterPromoCode: 'Ingrese el código de promoción',
      group: 'Crear grupo',
      content: 'Contenido',
      links: 'Enlaces',
      heading: 'Encabezado',
      settings: 'Configuración',
      thumbnail: 'Miniatura',
      typeTooltip: '  El clic abrirá este enlace',
      title: 'Título',
      titleTooltip: 'Nombre de su enlace',
      description: 'Descripción',
      descriptionTooltip: 'Descripción opcional de características del enlace, tipos, color, tallas, etc.',
      label: 'Etiqueta',
      labelTooltip: 'Agregar nombre de etiqueta',
      button: 'Botón',
      buttonTooltip: 'Agregar nombre del botón',
      buttonText: 'Texto del botón',
      buttonTextTooltip: 'Nombre de su botón',
      buttonUrl: 'URL del botón',
      buttonUrlTooltip: 'Ingrese la URL del botón',
      addLinkToGroup: 'Agregar enlace al grupo',
      removeFromGroup: 'Eliminar del grupo',
      deletePermanently: 'Eliminar permanentemente',
      image: 'Imagen',
      buttonBg: 'Fondo del botón',
      postPreview: 'Vista previa de la publicación',
      separatorType: 'Tipo de separador',
      separatorTypeTooltip: 'Agregar tipo de separador a su botón',
      section: 'Sección',
      sectionTooltip: 'Sección del enlace',
      descriptionSeparator: 'Descripción',
      descriptionSeparatorTooltip: 'Descripción opcional de la sección',
      sectionText: 'Texto de la sección',
      linkInstant: 'Reenvío instantáneo del enlace',
      spotlight: 'Destacar el enlace',
      addEffect: 'Agregar efecto especial',
      countdown: 'Cuenta regresiva',
      countdownTimer: 'Temporizador de cuenta regresiva',
      countdownText: 'Agregue una cuenta regresiva en vivo hasta que su enlace sea clickeable',
      chooseDate: 'Elegir fecha',
      chooseDateTooltip: 'Elija la fecha para su enlace',
      chooseAction: 'Elegir acción',
      chooseActionTooltip: 'Elija la acción para su enlace',
      addCountdown: 'Agregar cuenta regresiva para el enlace',
      scheduler: 'Programador',
      schedule: 'Programar',
      scheduleText: 'Elija una fecha y hora en el futuro para que su enlace se active',
      activateOn: 'Activar el',
      activateOnTooltip: 'Elegir fecha',
      deactivateOn: 'Desactivar el',
      deactivateOnTooltip: 'Elegir fecha',
      addSchedule: 'Agregar programación para',
      scheduleError: 'La fecha de finalización no puede ser anterior a la fecha de inicio y la fecha de inicio no puede estar en el pasado.',
      scheduleErrorPast: 'La fecha de activación no puede estar en el pasado.',
      scheduleErrorPastDeactivate: 'La fecha de desactivación no puede estar en el pasado.',
      scheduleErrorOrder: 'La fecha de desactivación debe ser posterior a la fecha de activación.',
      activatesIn: 'Se activa en',
      deactivatesIn: 'Se desactiva en',
      lock: 'Bloquear',
      lockText: 'Los visitantes solo pueden acceder a este enlace cumpliendo uno de los criterios.',
      lockCode: 'Código',
      lockCodeTitle: 'Código para desbloquear este enlace',
      lockCodeText: 'Los visitantes necesitan ingresar un código de 4 dígitos para desbloquear este enlace',
      lockSubscribe: 'Suscribirse',
      lockSubscribeTitle: 'Los visitantes deben suscribirse a su UniLink para desbloquear el enlace.',
      lockSubscribeText: 'El bloqueo se ha configurado exitosamente.',
      lockPayment: 'Pago',
      lockPaymentText: 'El bloqueo se ha configurado exitosamente.',
      price: 'Precio',
      priceTooltip: 'Agregue el precio de su producto',
      lockAge: 'Fecha de nacimiento (Edad)',
      lockAgeTitle: 'Establecer edad mínima',
      lockAgeText: 'Los visitantes deben tener cierta edad para desbloquear el enlace con su fecha de nacimiento',
      lockAgeAlert: 'El bloqueo se ha configurado exitosamente.',
      lockSensitive: 'Contenido sensible',
      lockSensitiveText: 'Los visitantes deben reconocer que este enlace puede contener contenido que no es apropiado para todas las audiencias.',
      makeLink: 'Hacer que el enlace sea de pago',
      addLock: 'Agregar bloqueo para el enlace',
      save: 'Guardar',
      clear: 'Limpiar',
      buttonColor: 'Color del botón',
      labelColor: 'Color de la etiqueta',
      background: 'Fondo',
      imageHeight: 'Altura de la imagen',
      imageHeightTooltip: 'Arrastre el control deslizante para cambiar la altura de la imagen',
      buttonMinimum: 'Altura mínima',
      buttonMinimumTooltip: 'Arrastre el control deslizante para cambiar la altura del botón',
      textPosition: 'Posición del texto',
      textPositionTooltip: 'Elige la posición vertical del texto',
      preview: 'vista previa',
      defaultDesign: 'Diseño predeterminado',
      defaultDesignTooltip: 'Configurar el diseño predeterminado para los enlaces',
      defaultDesignTitle: 'Tenga en cuenta que este diseño se aplicará a todos los enlaces.',
      defaultDesignText: 'Puede cambiar el diseño predeterminado del enlace',
      changeDefault: 'Cambiar predeterminado',
      applyDefault: 'Aplicar predeterminado',
      scheduled: 'Programado',
      scheduledVisible: 'El enlace programado ahora es visible',
      scheduledHidden: 'El enlace programado ahora está oculto',
      linkClickable: 'Enlace clickeable en',
      linkDisable: 'Enlace desactivado en',
      lockedBy: 'Bloqueado por',
      items: 'Elementos',
      doNotAnyLinks: 'Aún no tiene enlaces',
      sublinks: 'Sub-enlaces',
      layout: 'Diseño',
      layoutTooltip: 'Elija el diseño de sub-enlaces que desee',
      hideGroupLink: 'Ocultar enlace del grupo',
    },
    'data-collect': {
      blockTitle: 'Recopilación de datos',
      blockText: 'Recopile correos electrónicos o números de teléfono de sus visitantes',
      blockShortText: 'Recopilar correos electrónicos',
      maxSize: 'Puede agregar un máximo de 3 canales',
      customTerms: 'Términos personalizados',
      customTermsTooltip: 'Agregue términos y condiciones personalizados a su formulario',
      termsConditions: 'Términos y condiciones',
      text: 'Texto',
      subscribe: 'Suscribirse',
      title: 'Título',
      titleTooltip: 'Ingrese el título para los términos y condiciones',
      titleResultTooltip: 'Ingrese el título para su envío',
      url: 'URL',
      urlTooltip: 'Ingrese la URL',
      editItem: 'Editar elemento',
      placeholder: 'Placeholder',
      placeholderTooltip: 'Ingrese el texto del placeholder',
      button: 'Botón',
      buttonTooltip: 'Texto que motivará al visitante a ingresar su correo electrónico (10% de descuento, suscribirse ahora, descargar archivo, etc.)',
      successMessage: 'Mensaje de éxito',
      successMessageTooltip: 'Mensaje de éxito de sus suscriptores',
      botURL: 'URL del bot (opcional)',
      botURLTooltip: 'Ingrese la URL de su bot',
      botToken: 'Token del bot',
      botTokenTooltip: 'Ingrese el token de su bot',
      rewards: 'Respuestas',
      rewardsTooltip: 'Agregue respuestas de sus suscriptores',
      addReward: 'Agregar respuesta',
      thankYou: 'Mensaje de agradecimiento',
      email: {
        none: 'Ninguno',
        display: 'Mostrar respuesta instantáneamente',
        send: 'Enviar respuesta por correo electrónico',
        redirect: 'Redirigir a URL',
      },
      phone: {
        none: 'Ninguno',
        display: 'Mostrar respuesta instantáneamente',
        send: 'Enviar respuesta por teléfono',
        redirect: 'Redirigir a URL',
      },
      telegram: {
        none: 'Ninguno',
        display: 'Mostrar respuesta instantáneamente',
        send: 'Enviar respuesta en bot de Telegram',
        redirect: 'Redirigir a URL',
      },
      whatsapp: {
        none: 'Ninguno',
        display: 'Mostrar respuesta instantáneamente',
        send: 'Enviar respuesta en bot de WhatsApp',
        redirect: 'Redirigir a URL',
      },
      instagram: {
        none: 'Ninguno',
        display: 'Mostrar respuesta instantáneamente',
        send: 'Enviar respuesta en bot de Instagram',
        redirect: 'Redirigir a URL',
      },
      messenger: {
        none: 'Ninguno',
        display: 'Mostrar respuesta instantáneamente',
        send: 'Enviar respuesta en bot de Messenger',
        redirect: 'Redirigir a URL',
      },
      viber: {
        none: 'Ninguno',
        display: 'Mostrar respuesta instantáneamente',
        send: 'Enviar respuesta en bot de Viber',
        redirect: 'Redirigir a URL',
      },
      connect: 'Conectar',
      toChangeReward: 'Para cambiar el tipo de respuesta, debe eliminar la actual',
      remove: 'Eliminar',
      viewTypes: 'Tipos de vista',
    },
    form: {
      blockTitle: 'Formulario',
      blockText: 'Le permite capturar información y datos de su audiencia',
      blockShortText: 'Capturar información',
      fields: 'Campos',
      fieldsTooltip: 'Agregar campos al formulario',
      addCustomField: 'Agregar campo personalizado',
      addItem: 'Agregar elemento',
      editItem: 'Editar elemento',
      type: 'Tipo',
      typeTooltip: 'Elija el tipo de campo',
      string: 'Respuesta corta',
      textarea: 'Respuesta larga',
      dropdown: 'Desplegable',
      radio: 'Radio',
      checkbox: 'Checkbox',
      date: 'Fecha',
      time: 'Hora',
      country: 'País',
      fieldName: 'Nombre del campo',
      fieldNameTooltip: 'Ingrese el nombre del campo',
      name: 'Nombre',
      placeholder: 'Placeholder',
      placeholderTooltip: 'Ingrese el texto del placeholder',
      required: 'Obligatorio',
      requiredTooltip: 'Marque si el campo es obligatorio',
      value: 'Valor',
      enterTitle: 'Ingrese el título',
      addValue: 'Agregar valor',
      delete: 'Eliminar',
      update: 'Actualizar',
      add: 'Agregar',
      confirmationPage: 'Acción de confirmación',
      confirmationPageSubtitle: 'Elija la acción resultante después de enviar el formulario',
      successMessage: 'Mensaje de éxito',
      successMessageTooltip: 'Mensaje de éxito después de enviar el formulario',
      thankYou: 'Mensaje de agradecimiento',
      submit: 'Enviar',
    },
    contact: {
      blockTitle: 'Contactos',
      blockText: 'Contactos permite a los usuarios comunicarse directamente con usted. Agregue su teléfono, correo electrónico, mensajero o ubicación',
      blockShortText: 'Comunicarse con usuarios',
      addNewContact: 'Agregar nuevo contacto',
      newContact: 'Nuevo contacto',
      friendlyName: 'Nombre amigable',
    },
    faq: {
      blockTitle: 'FAQ',
      blockText: 'Preguntas frecuentes: se usa para referirse a una lista de respuestas a preguntas típicas que los usuarios podrían hacer',
      blockShortText: 'Preguntas frecuentes',
      addNewItem: 'Agregar nuevo elemento',
      editItem: 'Editar elemento',
      title: 'Título',
      titleTooltip: 'Ingrese el título',
      description: 'Descripción',
      descriptionTooltip: 'Ingrese la descripción',
      update: 'Actualizar',
      add: 'Agregar',
      howToFind: 'Cómo encontrarnos',
    },
    ama: {
      blockTitle: 'Pregúntame',
    },
    feature: {
      blockTitle: 'Características',
      blockText: 'Sección de texto con imagen para decirle a sus usuarios por qué su negocio es el mejor',
      blockShortText: 'Diga a sus usuarios por qué',
      title: 'Título',
      titleTooltip: 'Cambiar el título del elemento',
      description: 'Descripción',
      descriptionTooltip: 'Cambiar la descripción del elemento',
    },
    highlight: {
      blockTitle: 'Destacados',
      blockText: 'Destaque los enlaces más importantes con miniaturas (hasta 3)',
      blockShortText: 'Destaque lo más importante',
      title: 'Título',
      titleTooltip: 'Cambiar el título del elemento',
      url: 'URL',
      urlTooltip: 'Cambiar la URL del elemento',
    },
    banner: {
      blockTitle: 'Banner',
      blockText: 'Destaque una imagen, video o su último producto para que se resalte. Puede agregar un botón CTA para guiar a los usuarios hacia su conversión objetivo',
      blockShortText: 'Destacar imagen, video',
      height: 'Altura',
      heightTooltip: 'Cambiar la altura del banner',
    },
    slider: {
      blockTitle: 'Slider',
      blockText: 'Carrusel de imágenes que le permite mostrar el contenido de sus imágenes y agregar diferentes funciones',
      blockShortText: 'Carrusel de imágenes',
      image: 'Imagen',
      imageTooltip: 'Imagen de su galería',
      addText: 'Agregar texto',
      title: 'Título',
      titleTooltip: 'Título de su diapositiva',
      titleSize: 'Tamaño del título',
      titleSizeTooltip: 'Elija el tamaño para una mejor lectura',
      description: 'Descripción',
      descriptionTooltip: 'Descripción de su diapositiva',
      textColor: 'Color del texto',
      addButton: 'Agregar botón',
      url: 'URL',
      urlTooltip: 'URL de su imagen',
      button: 'Botón',
      buttonTooltip: 'Título de su botón',
      buttonText: 'Texto del botón',
      buttonColor: 'Color del botón',
      height: 'Altura',
      heightTooltip: 'Cambiar la altura de las diapositivas',
      view: 'Vista',
      viewTooltip: 'Elegir vista para el slider',
      auto: 'Automático',
      square: 'Cuadrado',
      rectangle: 'Rectángulo',
      single: 'Individual',
      multi: 'Múltiple',
    },
    gallery: {
      blockTitle: 'Galería',
      blockText: 'Carrusel de imágenes que le permite mostrar el contenido de sus imágenes',
      blockShortText: 'Carrusel de imágenes',
      image: 'Imagen',
      imageTooltip: 'Imagen del elemento de su galería',
      layout: 'Diseño',
      layoutTooltip: 'Elegir diseño para la galería',
      feed: 'Feed',
      slider: 'Slider',
    },
    blog: {
      blockTitle: 'Blog',
      blockText: 'Cree un blog de sus publicaciones',
      blockShortText: 'Crear blog',
      writeYourStory: 'Escriba su historia',
      shortDescription: 'Descripción corta',
      shortDescriptionTooltip: 'Descripción opcional para su blog',
      description: 'Descripción',
    },
    map: {
      blockTitle: 'Mapa',
      blockText: 'Agregue un mapa de Google para ayudar a los usuarios a navegar hasta su negocio local',
      blockShortText: 'Agregar mapa de Google',
      buttonText: 'Texto del botón',
      buttonTextTooltip: 'El botón aparece cuando se selecciona la segunda vista',
      text: 'Texto',
      addAddress: 'Agregar otra dirección',
      address: 'Dirección',
      addressTooltip: 'Pegue la dirección de Google Maps, por ejemplo',
      googleMap: 'Google Maps (código embed)',
      googleMapTooltip: 'Pegue el código embed de Google Maps',
      howToFind: 'Cómo encontrar el código embed',
      incorrectCode: 'Código embed incorrecto.',
      moreInfo: 'Más información',
      code: 'Código',
      addressSettings: 'Configuración de dirección',
      addressContent: 'Agregue URL, título y texto del botón o ícono',
      title: 'Título',
      titleTooltip: 'El nombre de su dirección',
      url: 'URL',
      urlTooltip: 'Pegue la URL de la dirección de Google Maps, por ejemplo',
      directionText: 'Texto de dirección',
      directionTextTooltip: 'Texto de llamada a la acción para sus usuarios',
    },
    footer: {
      blockTitle: 'Pie de página',
      blockText:
        'Sección de contenido en la parte inferior de una página. Puede agregar información de contacto, íconos de redes sociales y un formulario de registro por correo electrónico',
      blockShortText: 'Sección de contenido inferior',
      addBlock: 'Agregar bloque',
      blockType: 'Tipo de bloque',
      blockTypeTooltip: 'Elegir tipo de bloque',
      addBlockTitle: 'Título del bloque',
      addBlockTitleTooltip: 'Elegir título del bloque',
      faq: 'FAQ',
      'data-collect': 'Recopilación de datos',
      contact: 'Contacto',
      pages: 'Páginas',
      payments: 'Pagos',
      social: 'Social',
      cancel: 'Cancelar',
      add: 'Agregar',
      None: 'Ninguno',
      link: 'enlace',
      faqText: 'Puede editar las preguntas frecuentes en el bloque FAQ. Puede navegar a él haciendo clic en este',
      socialText: 'Puede editar los íconos sociales en el bloque de encabezado. Puede navegar a él haciendo clic en este',
      dataCollectText: 'Puede editar la recopilación de datos en el bloque de Recopilación de datos. Puede navegar a él haciendo clic en este',
      contactText: 'Puede editar el contacto en el bloque de Contacto. Puede navegar a él haciendo clic en este',
      pagesText: 'Puede agregar nuevas páginas en el sitio web',
      paymentsText: 'Se mostrarán los métodos de pago',
      showOnAllpages: 'Mostrar en todas las páginas',
      footerText: 'El pie de página de la página de inicio está actualmente habilitado.',
      editSocialIcons: 'Puede editar los íconos sociales en la sección de encabezado. Puede navegar a ella haciendo clic en este',
      editSubscribe: 'Puede editar la suscripción en la sección de suscripción. Puede navegar a ella haciendo clic en este',
      editContacts: 'Puede editar los contactos en la sección de contactos. Puede navegar a ella haciendo clic en este',
      editFrequently: 'Puede editar las preguntas frecuentes en la sección de FAQ. Puede navegar a ella haciendo clic en este',
    },
    'chat-ai': {
      blockTitle: 'Chat IA',
      blockShortText: 'Chatear con IA',
      blockText: 'Chatear con IA',
      suggestionsTitle: 'Sugerencias',
      suggestionsSubtitle: 'Indicaciones rápidas',
    },
    custom: {
      blockTitle: 'Personalizado',
      blockShortText: 'Micro aplicación con IA',
      blockText: 'Describa una mini aplicación interactiva y la IA la generará por usted',
    },
    shop: {
      blockTitle: 'Tienda',
      blockText: 'Agregue su lista de productos',
      blockShortText: 'Agregar sus productos',
      view: 'Vista',
      products: 'Productos',
      categories: 'Categorías',
    },
    digital: {
      blockTitle: 'Productos digitales',
      blockText: 'Venda una descarga digital: PDFs, hojas de cálculo, plantillas, exclusivas',
      blockShortText: 'Vender digital',
    },
    podcast: {
      blockTitle: 'Podcasts',
      blockText: 'Promocione sus podcasts',
      blockShortText: 'Promocionar sus podcasts',
    },
    'page-list': {
      blockTitle: 'Lista de páginas',
      blockText: 'Cree su lista de páginas',
      blockShortText: 'Crear su lista de páginas',
    },
    appointment: {
      blockTitle: 'Citas',
      blockText: 'Permita que los visitantes reserven tiempo en su calendario',
      blockShortText: 'Permitir reservas',
    },
    service: {
      blockTitle: 'Servicios',
      blockText: 'Recibirá una notificación por correo electrónico cuando se le envíe una solicitud',
      blockShortText: 'Recibir correo electrónico',
    },
    requests: {
      blockTitle: 'Servicios',
      blockText: 'Recibirá una notificación por correo electrónico cuando se le envíe una solicitud',
      blockShortText: 'Recibir correo electrónico',
    },
    tips: {
      blockTitle: 'Propinas',
      blockText: 'UniLink hace que apoyar sea divertido y fácil. Con solo un par de toques, sus fans pueden realizar el pago y dejar un mensaje',
      blockShortText: 'Apoyar es divertido',
    },
    tip: {
      blockTitle: 'Propinas',
      blockText: 'UniLink hace que apoyar sea divertido y fácil. Con solo un par de toques, sus fans pueden realizar el pago y dejar un mensaje',
      blockShortText: 'Apoyar es divertido',
    },
    donation: {
      blockTitle: 'Donaciones',
      blockText: 'UniLink hace que apoyar sea divertido y fácil. Con solo un par de toques, sus fans pueden realizar el pago y dejar un mensaje',
      blockShortText: 'Apoyar es divertido',
    },
    course: {
      blockTitle: 'Curso o tutorial',
      blockText: 'Permita que los visitantes reserven tiempo en su calendario',
      blockShortText: 'Permitir reservas',
    },
    event: {
      blockTitle: 'Eventos o entradas',
      blockText: 'Permita que la audiencia asista a sus eventos',
      blockShortText: 'Permitir asistencia',
    },
    menu: {
      blockTitle: 'Menú',
      blockText: 'Cree un menú único con precios',
      blockShortText: 'Crear menú único',
    },
    booking: {
      blockTitle: 'Reservas',
      blockText: 'Permita que los visitantes reserven sus espacios',
      blockShortText: 'Permitir reservas',
      name: 'Nombre',
      nameCaption: 'Ingrese el nombre del espacio',
      description: 'Descripción',
      descriptionCaption: 'Descripción corta para este espacio',
      rentalType: 'Tipo de alquiler',
      rentalTypeCaption: 'Por ejemplo: apartamento, coche, oficina',
      duration: 'Duración',
      durationCaption: 'Por ejemplo: por día, por semana, por mes',
      price: 'Precio',
      priceCaption: 'Precio base para este espacio',
      oldPrice: 'Precio anterior',
      oldPriceCaption: 'Precio anterior opcional',
      rating: 'Calificación',
      ratingCaption: 'Calificación promedio (opcional)',
      label: 'Etiqueta',
      labelCaption: 'Insignia corta como OFERTA o NUEVO',
      image: 'Imagen',
      imageCaption: 'Suba una imagen de portada para este espacio',
      location: 'Ubicación',
      locationCaption: 'Ciudad, área o dirección',
      capacity: 'Capacidad (huéspedes)',
      capacityCaption: 'Número máximo de huéspedes',
      rooms: 'Habitaciones y área',
      roomsCaption: 'Dormitorios, baños y área',
      bedrooms: 'Dormitorios',
      bathrooms: 'Baños',
      areaSqM: 'Área (m²)',
      minStay: 'Estancia mínima (días)',
      minStayCaption: 'Número mínimo de días para la reserva',
      requiresDeposit: 'Requiere depósito',
      depositAmount: 'Monto del depósito',
      depositAmountCaption: 'Depósito inicial para confirmar la reserva',
      noSmoking: 'No fumar',
      noPets: 'No mascotas',
      amenitiesWifi: 'Wi-Fi',
      amenitiesParking: 'Estacionamiento',
      amenitiesKitchen: 'Cocina',
      amenitiesHeating: 'Calefacción',
      amenitiesAC: 'Aire acondicionado',
      amenitiesPool: 'Piscina',
      amenitiesSauna: 'Sauna',
      amenitiesRestrooms: 'Baños',
      validationNameRequired: 'El nombre es obligatorio',
      validationPriceRequired: 'El precio debe ser un número no negativo',
      validationDepositRequired: 'El monto del depósito es obligatorio cuando el depósito está habilitado',
      validationCapacityNumber: 'La capacidad debe ser un número no negativo',
      validationOldPriceNumber: 'El precio anterior debe ser un número no negativo',
      brand: 'Marca',
      brandCaption: 'Marca del coche, ej. Tesla',
      model: 'Modelo',
      modelCaption: 'Modelo del coche, ej. Model 3',
      year: 'Año',
      yearCaption: 'Año de fabricación',
      color: 'Color',
      colorCaption: 'Color exterior, ej. negro',
      fuelType: 'Tipo de combustible',
      fuelTypeCaption: 'Gasolina, diésel, eléctrico, híbrido, etc.',
      transmission: 'Transmisión',
      transmissionCaption: 'Automática o manual',
      seatCount: 'Número de asientos',
      seatCountCaption: 'Número de asientos en el coche',
      edit: 'Editar elemento',
      add: 'Agregar elemento',
    },
    membership: {
      blockTitle: 'Membresía',
      blockText: 'Cree una suscripción gratuita o de pago a su contenido',
      blockShortText: 'Crear suscripción',
    },
    pricing: {
      blockTitle: 'Precios',
      blockText: 'Cree un menú único con precios',
      blockShortText: 'Crear menú único',
      name: 'Nombre',
      nameTooltip: 'Ingrese el nombre de su producto',
      pricingPlanName: 'Nombre del plan de precios',
      pricingPlanNameTooltip: 'Ingrese el nombre de su plan de precios',
      description: 'Descripción',
      descriptionTooltip: 'Ingrese la descripción de su producto',
      pricingPlanDescriptionTooltip: 'Ingrese la descripción de su plan de precios',
      priceValue: 'Valor del precio',
      priceUnit: 'Unidad del precio',
      label: 'Etiqueta',
      labelTooltip: 'Ingrese la etiqueta de su plan de precios',
      orderButtonText: 'Texto del botón de pedido',
      orderButtonTextDescriptionTooltip: 'Ingrese el texto del botón de pedido de su plan de precios',
      orderButtonLink: 'Enlace del botón de pedido',
      orderButtonLinkDescriptionTooltip: 'Ingrese el enlace del botón de pedido de su plan de precios',
      subtitle: 'Subtítulo',
      subtitleTooltip: 'Ingrese el subtítulo de su producto',
      price: 'Precio',
      priceTooltip: 'Ingrese el precio de su producto',
      pricingTiers: 'Niveles de precios',
      pricingTiersTooltip: 'Ingrese los niveles de precios de su producto',
      addPriceValue: 'Agregar más precios',
      group: 'Grupo',
      groupTooltip: 'Elija el grupo de su producto',
      image: 'Imagen',
      imageTooltip: 'Suba una imagen para su producto',
      unit: 'Unidad del precio',
      unitTooltip: 'Ingrese la unidad de su precio',
      addUnitTitle: 'Unidades de precio',
      addPriceUnitValue: 'Agregar más unidades de precio',
      addUnitButtonText: 'Guardar',
      button: 'Botón',
      buttonTooltip: 'Agregar botón para su producto',
      buttonAddText: '+ Agregar botón',
      buttonModalTextField: 'Texto del botón',
      buttonModalTextFieldTooltip: 'Ingrese el texto del botón',
      buttonModalURLField: 'URL del botón',
      buttonModalURLFieldTooltip: 'Ingrese la URL del botón',
      buttonModalTitle: 'Agregar botón',
      groups: {
        title: 'Grupos',
        subtitle: 'Agregar, editar y eliminar grupos',
        groups: 'Grupos',
        groupsTooltip: 'Agregar, editar y eliminar grupos',
        addNewGroup: 'Agregar nuevo grupo',
        newGroup: 'Nuevo grupo',
        titleGroup: 'Título',
        titleGroupTooltip: 'Ingrese el título de su grupo',
        descriptionGroup: 'Descripción',
        descriptionGroupTooltip: 'Ingrese la descripción de su grupo',
      },
    },
    menuBlock: {
      title: 'Menú',
      subtitle: 'Cree un menú con elementos y precios',
      add: 'Agregar nuevo elemento',
      edit: 'Editar elemento',
      name: 'Nombre',
      nameCaption: 'Ingrese el nombre del elemento',
      description: 'Descripción',
      descriptionCaption: 'Ingrese una descripción corta',
      ingredients: 'Ingredientes',
      ingredientsCaption: 'Liste los ingredientes o composición',
      price: 'Precio',
      priceCaption: 'Ingrese el precio',
      weight: 'Peso (g)',
      weightCaption: 'Ingrese el peso en gramos',
      calories: 'Calorías (kcal)',
      caloriesCaption: 'Ingrese las calorías en kcal',
      label: 'Etiqueta',
      labelCaption: 'Ingrese el texto de la etiqueta',
      labelColor: 'Color de la etiqueta',
      labelColorCaption: 'Elija un color de fondo para la etiqueta',
      image: 'Imagen',
      imageCaption: 'Suba una imagen para su elemento',
      available: 'Disponible para pedido',
      visible: 'Visible en la página',
    },
    nft: {
      blockTitle: 'NFT',
      blockText: 'Muestre un NFT de la plataforma OpenSea',
      blockShortText: 'Mostrar un NFT',
    },
    wallet: {
      wallet: 'Billetera',
      blockTitle: 'Billetera bancaria/cripto',
      blockText: 'Muestre su tarjeta de crédito o billetera Bitcoin para facilitar a sus usuarios copiarla y transferir fondos',
      blockShortText: 'Mostrar sus billeteras',
      title: 'Título',
      titleTooltip: 'Título de su billetera',
      walletNumber: 'Número de billetera',
      walletNumberTooltip: 'Pegue su número de billetera',
      icon: 'Ícono',
      iconTooltip: 'Establecer ícono para su billetera',
      card: 'Tarjeta',
      bank: 'Banco',
      crypto: 'Cripto',
      transfer: 'Transferencia',
      paymentLink: 'Enlace de pago',
      cardNumber: 'Número de tarjeta',
      cardNumberTooltip: 'Pegue su número de tarjeta',
      cardHolder: 'Titular de la tarjeta',
      cardHolderTooltip: 'Ingrese el titular de la tarjeta',
      bankAccountDetails: 'Detalles de la cuenta bancaria',
      bankAccountDetailsTooltip: 'Ingrese los detalles de su cuenta bancaria',
      walletAddress: 'Dirección de la billetera',
      walletAddressTooltip: 'Ingrese la dirección de su billetera',
      network: 'Red',
      networkTooltip: 'Ingrese su red',
      publicKey: 'Clave pública',
      publicKeyTooltip: 'Ingrese su clave pública',
      providerName: 'Nombre del proveedor',
      providerNameTooltip: 'Ingrese el nombre de su proveedor',
      link: 'Enlace',
      linkTooltip: 'Ingrese su enlace',
      serviceName: 'Nombre del servicio',
      serviceNameTooltip: 'Ingrese el nombre de su servicio',
      email: 'Correo electrónico',
      emailTooltip: 'Ingrese su correo electrónico',
      phone: 'Teléfono',
      phoneTooltip: 'Ingrese su teléfono',
      username: 'Nombre de usuario',
      usernameTooltip: 'Ingrese su nombre de usuario',
      fullName: 'Nombre completo',
      fullNameTooltip: 'Ingrese su nombre completo',
      referenceNumber: 'Número de referencia',
      referenceNumberTooltip: 'Ingrese su número de referencia',
      country: 'País',
      countryTooltip: 'Ingrese su país',
      transferProvider: 'Proveedor de transferencia',
      transferProviderTooltip: 'Ingrese su proveedor de transferencia',
      cryptoCurrency: 'Criptomoneda',
      cryptoCurrencyTooltip: 'Ingrese su criptomoneda',
    },
    instagram: {
      blockTitle: 'Instagram',
      blockText: 'Destaque sus mejores medios y videos de Instagram o venda sus productos con un feed de Instagram comprable',
      blockShortText: 'Sus mejores medios de Instagram',
      blockConnectTitle: 'Instagram no está conectado',
      blockConnectText: 'Parece que sus productos de Instagram aún no se han importado. Conecte su cuenta ahora',
      blockConnectButton: 'Agregar Instagram',
      emptyList: 'Aún no tiene medios de Instagram.',
      addInstagramUsername: 'Agregar nombre de usuario de Instagram',
      username: 'Nombre de usuario',
      downloadTakes: 'La descarga tarda hasta 2 minutos',
      displayPost: 'Mostrar publicación en su sitio web',
      view: 'Vista',
      redirect: 'Redirección URL',
      text: 'Texto y botón',
      actionType: 'Tipo de acción',
      url: 'URL',
      openInNewTab: 'Abrir en nueva pestaña',
      delete: 'Eliminar',
      cancel: 'Cancelar',
      save: 'Guardar',
      editMedia: 'Editar medio',
      title: 'Título',
      automation: 'Automatización',
      automationText: 'Automatice su cuenta con funciones de piloto automático',
      autopilot: 'Piloto automático',
      autopilotTooltip: 'Suba una publicación con la descripción de ejemplo y sus etiquetas/enlaces de productos se generarán automáticamente',
      switchTitle: 'Detectar automáticamente título, precio, enlaces',
      sampleCaption: 'Descripción de ejemplo: #49.99 #VestidoBonito https://google.com',
      integrations: 'Integraciones',
      integrationsText: 'Agregue Instagram a su sitio web',
      connectInstagram: 'Conectar Instagram',
      connectInstagramText: 'Conecte su cuenta de Instagram para mostrar sus publicaciones o reels elegidos.',
      selectAccount: 'Seleccionar cuenta',
      connectNewInstagram: 'Conectar una nueva cuenta de Instagram',
      continue: 'Continuar',
      disconnectInstagram: 'Desconectar Instagram',
      addTag: 'Añadir etiqueta',
      tagClickHint: 'Haz clic en la imagen para colocar la etiqueta',
      tagPositionSet: 'Posición establecida. Completa los detalles a continuación.',
      tagTypeLink: 'Enlace',
      tagTypeProduct: 'Producto',
      tagLabel: 'Etiqueta',
      tagSelectProduct: 'Seleccionar producto',
    },
    tiktok: {
      blockTitle: 'TikTok',
      blockText: 'Destaque su mejor video de TikTok o venda sus productos con un feed de TikTok comprable',
      blockShortText: 'Su mejor video de TikTok',
      addTikTok: 'Agregar cuenta de TikTok',
      individualVideo: 'Video individual',
      videoCollection: 'Colección de videos',
      add: 'Agregar',
      blockConnectTitle: 'TikTok no está conectado',
      blockConnectText: 'Parece que sus productos de TikTok aún no se han importado. Conecte su cuenta ahora',
      blockConnectButton: 'Conectar TikTok',
      enterUsername: 'Ingrese nombre de usuario',
      enterVideo: 'Ingrese una URL de video de TikTok',
      emptyList: 'Aún no tiene medios de TikTok.',
      editMedia: 'Editar medio',
      addTikTokVideo: 'Agregar video de TikTok',
      displayPost: 'Mostrar publicación en su sitio web',
      delete: 'Eliminar',
      cancel: 'Cancelar',
      save: 'Guardar',
      integrations: 'Integraciones',
      integrationsText: 'Agregue TikTok a su sitio web',
      connectTikTok: 'Conectar TikTok',
      disconnectTikTok: 'Desconectar TikTok',
      individualText: "No puede conectar una cuenta de TikTok a este tipo de bloque ('individual').",
      individualText2: 'Por favor, agregue un video individual de TikTok en su lugar.',
    },
    youtube: {
      blockTitle: 'YouTube',
      blockText: 'Destaque un video o transmisión de YouTube en su página. Etiquete productos en el video de YouTube',
      blockShortText: 'Destacar un video de YouTube',
      enterYouTubeLink: 'Ingrese la URL de YouTube',
      enterYouTubeLinkTooltip: 'Pegue la URL de YouTube',
    },
    overview: {
      blockTitle: 'Resumen',
      blockText: 'Destaque un video o transmisión en su página. Etiquete productos en el video',
      blockShortText: 'Etiquetar productos en video',
    },
    video: {
      blockTitle: 'Video',
      blockText: 'Destaque un video o transmisión en su página. Etiquete productos en el video',
      blockShortText: 'Destacar un video',
    },
    twitter: {
      blockTitle: 'X (Twitter)',
      blockText: 'Muestre sus tweets en su página de UniLink para aumentar la interacción',
      blockShortText: 'Mostrar sus tweets',
      twitterURL: 'URL de Twitter',
      twitterURLTooltip: 'Agregue la URL de Twitter para generar el código embed',
      enterTwitterURL: 'Ingrese una URL de Twitter',
    },
    music: {
      blockTitle: 'Música',
      blockText: 'Inserte una canción o lista de reproducción de Spotify, SoundCloud o suba su propio archivo de audio',
      blockShortText: 'Agregar su música',
      brand: 'Marca',
      brandTooltip: 'Elija el tipo para agregar su música',
      url: 'URL',
      embed: 'Código embed',
      custom: 'Personalizado',
      musicUrl: 'URL de música',
      musicUrlTooltip: 'Ingrese la URL de la música',
      embedCodeTitle: 'Código embed',
      embedCodeTooltip: 'Pegue el código embed de su canción de la plataforma de música elegida',
      audioFile: 'Archivo de audio',
      uploadAudios: 'Solo puede subir audio aquí',
      title: 'Título',
      titleTooltip: 'Ingrese el título de su música',
      artist: 'Artista',
      artistTooltip: 'Ingrese el artista de su música',
      audioFileTitle: 'Archivo de audio',
      audioFileTooltip: 'Nombre de su archivo de audio',
      coverImage: 'Imagen de portada',
      coverImageTooltip: 'Suba una imagen para su música',
    },
    twitch: {
      blockTitle: 'Twitch',
      blockText: 'Inserte un video o transmisión de Twitch en su página',
      blockShortText: 'Insertar video de Twitch',
      twitchURL: 'URL de Twitch',
      twitchURLTooltip: 'Pegue la URL del canal o el nombre del canal',
      twitchTV: 'twitch.tv/...',
      displayTwitch: 'Mostrar mi canal de Twitch',
      displayChat: 'Mostrar mi canal de Twitch y el chat',
    },
    splash: {
      blockTitle: 'Pantalla de bienvenida',
      blockText: 'Banner de pantalla completa con texto y botón que aparece antes de la carga del sitio para promocionar cualquier producto o evento',
      blockShortText: 'Banner de pantalla completa',
    },
    promo: {
      blockTitle: 'Barra promocional',
      blockText: 'Destacado que le permite mostrar promociones',
      blockShortText: 'Destacar sus promociones',
    },
    welcome: {
      blockTitle: 'Mensaje de bienvenida',
      blockText:
        'Escriba mensajes de bienvenida que inviten a los visitantes a comenzar a chatear. Aparece en la parte inferior de la página para dar la bienvenida a los visitantes y ofrecer asistencia',
      blockShortText: 'Escribir mensajes de bienvenida',
    },
    review: {
      blockTitle: 'Reseñas',
      blockText: 'Las reseñas ayudan a los clientes a aprender más sobre el producto y decidir si es el producto adecuado para ellos',
      blockShortText: 'Reseñas de clientes',
      name: 'Nombre',
      nameTooltip: 'Ingrese el nombre del reseñador',
      comment: 'Comentario',
      commentTooltip: 'Ingrese el comentario del reseñador',
      date: 'Fecha',
      dateTooltip: 'Ingrese la fecha de la reseña',
      rate: 'Calificación',
      rateTooltip: 'Establecer calificación de la reseña',
      image: 'Imagen',
      imageTooltip: 'Subir imagen del reseñador',
    },
    coupon: {
      blockTitle: 'Cupones',
      blockText: 'Un cupón en línea se refiere a un código de descuento o número que se puede canjear en un sitio web',
      blockShortText: 'Cupón en línea',
    },
    timer: {
      blockTitle: 'Temporizador',
      blockText:
        'Un temporizador de cuenta regresiva es un reloj virtual en una página que cuenta desde un número o fecha determinado para indicar el inicio o fin de un evento u oferta',
      blockShortText: 'Temporizador de cuenta regresiva',
    },
    outfit: {
      blockTitle: 'Outfits',
      blockText: 'Cree su propia lista de productos',
      blockShortText: 'Crear lista de productos',
    },
    spacer: {
      blockTitle: 'Espaciador',
      blockText: 'Agregue un espacio vertical vacío a su página',
      blockShortText: 'Agregar espacio vacío',
    },
    html: {
      blockTitle: 'Código HTML',
      blockText:
        'Puede pegar su propio código HTML en la página de UniLink. HTML es un lenguaje de marcado estándar para la creación de páginas web. Permite iframes, secciones, párrafos y enlaces.',
      blockShortText: 'Pegar su propio HTML',
      markupCode: 'Código de marcado',
      markupCodeTooltip: 'Pegue el código de marcado de su HTML',
    },
    unlock: {
      blockTitle: 'Desbloquear',
      blockText: 'Puede agregar su contenido desbloqueable a la página de UniLink.',
      blockShortText: 'Pegar su archivo desbloqueable',
    },
    file: {
      blockTitle: 'Archivo',
      blockText:
        'Este bloque le permite subir y compartir archivos como documentos, imágenes o audio. Los visitantes pueden verlos o descargarlos fácilmente directamente desde su página.',
      blockShortText: 'Subir y compartir sus archivos.',
      addNewItem: 'Agregar nuevo archivo',
      editFile: 'Editar archivo',
      fileName: 'Ingrese el nombre del archivo',
    },
    stat: {
      blockTitle: 'Estadísticas',
      blockText:
        'Este bloque le permite mostrar información clave sobre su página, como vistas, visitantes o interacción. Le ayuda a monitorear su audiencia y entender cómo funciona su página.',
      blockShortText: 'Agregar estadísticas a su página.',
      addNewItem: 'Agregar nueva estadística',
      editItem: 'Editar estadística',
      statName: 'Ingrese el nombre de la estadística',
      statValue: 'Ingrese el valor de la estadística',
      statDescription: 'Ingrese la descripción de la estadística',
      statItemFields: 'Seleccione los campos a mostrar.',
      feed: 'Feed',
      slider: 'Slider',
      titleSize: 'Tamaño del título',
      subtitleTitleSize: 'Puede cambiar el tamaño del título',
    },
    listing: {
      blockTitle: 'Listado',
      blockText: 'Muestra propiedades o artículos con imágenes, detalles y precios.',
      blockShortText: 'Añade listados a tu página.',
    },
    rental: {
      blockTitle: 'Alquiler',
      blockText: 'Lista propiedades o artículos en alquiler con disponibilidad y precios por período.',
      blockShortText: 'Añade alquileres a tu página.',
    },
    'single-product': {
      blockTitle: 'Producto único',
      blockText: 'Destaca un producto único con imagen, descripción y botón de compra.',
      blockShortText: 'Destaca un producto.',
    },
    team: {
      blockTitle: 'Equipo',
      blockText: 'Presenta a los miembros de tu equipo con fotos, nombres, roles y enlaces sociales.',
      blockShortText: 'Muestra tu equipo.',
    },
    timetable: {
      blockTitle: 'Horario',
      blockText: 'Muestra un horario semanal con clases, eventos o sesiones.',
      blockShortText: 'Añade un horario semanal.',
    },
  },
};
